export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AddDiscountCodeInput = {
  code: Scalars['String'];
};

export enum Allergen {
  Eggs = 'EGGS',
  Fish = 'FISH',
  Milk = 'MILK',
  Peanuts = 'PEANUTS',
  Shellfish = 'SHELLFISH',
  Soybean = 'SOYBEAN',
  TreeNuts = 'TREE_NUTS',
  Wheat = 'WHEAT'
}

export type CancellationFeedback = {
  __typename?: 'CancellationFeedback';
  feedback?: Maybe<Scalars['String']>;
  final_notes?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  rating: Scalars['Float'];
  reason: CancellationReasons;
  subscription_id: Scalars['String'];
};

export type CancellationFeedbackInput = {
  feedback?: InputMaybe<Scalars['String']>;
  final_notes?: InputMaybe<Scalars['String']>;
  rating: Scalars['Float'];
  reason: CancellationReasons;
};

export enum CancellationReasons {
  DontLike = 'DONT_LIKE',
  NotUsing = 'NOT_USING',
  Other = 'OTHER',
  TooComplicated = 'TOO_COMPLICATED',
  TooExpensive = 'TOO_EXPENSIVE',
  TooMany = 'TOO_MANY'
}

export type CreateAddressInput = {
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  customer_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name: Scalars['String'];
  is_default?: InputMaybe<Scalars['Boolean']>;
  last_name: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
};

export type CreateUserInput = {
  confirm_password?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  first_name?: InputMaybe<Scalars['String']>;
  hashed_password?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  meal_preferences?: InputMaybe<MealPreferencesInput>;
  new_password?: InputMaybe<Scalars['String']>;
  postal_code: Scalars['String'];
  promo_code?: InputMaybe<Scalars['String']>;
  referral_code?: InputMaybe<Scalars['String']>;
  selectedPlan: Scalars['String'];
};

export type CreateUserSubscriptionInput = {
  product_variant_id: Scalars['String'];
  promo_code?: InputMaybe<Scalars['String']>;
  referral_code?: InputMaybe<Scalars['String']>;
};

export enum DietType {
  DairyFree = 'DAIRY_FREE',
  Flexitarian = 'FLEXITARIAN',
  GlutenFree = 'GLUTEN_FREE',
  HighProtein = 'HIGH_PROTEIN',
  LowCarb = 'LOW_CARB',
  MeatBased = 'MEAT_BASED',
  NonSpicy = 'NON_SPICY',
  NoRedMeat = 'NO_RED_MEAT',
  Pescatarian = 'PESCATARIAN',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

export type DietaryNutrients = {
  __typename?: 'DietaryNutrients';
  added_sugar: Scalars['Float'];
  calcium: Scalars['Float'];
  calories: Scalars['Float'];
  carbohydrate: Scalars['Float'];
  chlorine: Scalars['Float'];
  cholesterol: Scalars['Float'];
  copper: Scalars['Float'];
  fat: Scalars['Float'];
  fat_monounsaturated: Scalars['Float'];
  fat_polyunsaturated: Scalars['Float'];
  fat_saturated: Scalars['Float'];
  fat_trans: Scalars['Float'];
  fiber: Scalars['Float'];
  folate: Scalars['Float'];
  folic_acid: Scalars['Float'];
  iron: Scalars['Float'];
  magnesium: Scalars['Float'];
  manganese: Scalars['Float'];
  niacin: Scalars['Float'];
  phosphorus: Scalars['Float'];
  potassium: Scalars['Float'];
  protein: Scalars['Float'];
  riboflavin: Scalars['Float'];
  selenium: Scalars['Float'];
  sodium: Scalars['Float'];
  sugar: Scalars['Float'];
  sugar_alcohol: Scalars['Float'];
  thiamin: Scalars['Float'];
  uncounted_fiber: Scalars['Float'];
  vitamin_a_IU: Scalars['Float'];
  vitamin_b6: Scalars['Float'];
  vitamin_b12: Scalars['Float'];
  vitamin_c: Scalars['Float'];
  vitamin_d_IU: Scalars['Float'];
  vitamin_e: Scalars['Float'];
  vitamin_k: Scalars['Float'];
  zinc: Scalars['Float'];
};

export type FinishOnboardingInput = {
  email: Scalars['String'];
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  postal_code: Scalars['String'];
  shipping_address: CreateAddressInput;
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  token: Scalars['String'];
  user: User;
};

export type MjmlEmailPreview = {
  __typename?: 'MJMLEmailPreview';
  html: Scalars['String'];
};

export type MealPreferencesInput = {
  allergens?: InputMaybe<Array<Allergen>>;
  diets?: InputMaybe<Array<DietType>>;
};

export type MealPreferencesModel = {
  __typename?: 'MealPreferencesModel';
  allergens?: Maybe<Array<Allergen>>;
  diets?: Maybe<Array<DietType>>;
};

export type MedusaAddress = {
  __typename?: 'MedusaAddress';
  address_1: Scalars['String'];
  address_2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  country_code: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  customer_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  first_name: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  last_name: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  phone?: Maybe<Scalars['String']>;
  postal_code: Scalars['String'];
  province: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type MedusaAddressInput = {
  address_1: Scalars['String'];
  address_2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  country_code: Scalars['String'];
  created_at?: InputMaybe<Scalars['DateTime']>;
  customer_id?: InputMaybe<Scalars['String']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  first_name: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  last_name: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code: Scalars['String'];
  province: Scalars['String'];
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export enum MedusaAllocationType {
  Item = 'ITEM',
  Total = 'TOTAL'
}

export type MedusaCart = {
  __typename?: 'MedusaCart';
  billing_address?: Maybe<MedusaAddress>;
  billing_address_id?: Maybe<Scalars['String']>;
  completed_at?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['DateTime']>;
  customer_id?: Maybe<Scalars['String']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  discount_total?: Maybe<Scalars['Float']>;
  discounts?: Maybe<Array<MedusaDiscount>>;
  email?: Maybe<Scalars['String']>;
  gift_card_total?: Maybe<Scalars['Float']>;
  gift_cards?: Maybe<Array<MedusaGiftCard>>;
  id: Scalars['String'];
  items: Array<MedusaLineItem>;
  metadata?: Maybe<Scalars['JSON']>;
  payment_authorized_at?: Maybe<Scalars['DateTime']>;
  region_id: Scalars['String'];
  shipping_address?: Maybe<MedusaAddress>;
  shipping_address_id?: Maybe<Scalars['String']>;
  shipping_total?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  tax_total?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  type: MedusaCartType;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export enum MedusaCartType {
  Claim = 'CLAIM',
  Default = 'DEFAULT',
  DraftOrder = 'DRAFT_ORDER',
  PaymentLink = 'PAYMENT_LINK',
  Swap = 'SWAP'
}

export enum MedusaClaimFulfillmentStatus {
  Canceled = 'CANCELED',
  Fulfilled = 'FULFILLED',
  NotFulfilled = 'NOT_FULFILLED',
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  PartiallyReturned = 'PARTIALLY_RETURNED',
  PartiallyShipped = 'PARTIALLY_SHIPPED',
  RequiresAction = 'REQUIRES_ACTION',
  Returned = 'RETURNED',
  Shipped = 'SHIPPED'
}

export type MedusaClaimImage = {
  __typename?: 'MedusaClaimImage';
  claim_item: MedusaClaimItem;
  claim_item_id: Scalars['String'];
  created_at: Scalars['DateTime'];
  deleted_at: Scalars['DateTime'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  updated_at: Scalars['DateTime'];
  url: Scalars['String'];
};

export type MedusaClaimItem = {
  __typename?: 'MedusaClaimItem';
  claim_order: MedusaClaimOrder;
  claim_order_id: Scalars['String'];
  created_at: Scalars['DateTime'];
  deleted_at: Scalars['DateTime'];
  id: Scalars['String'];
  images: Array<MedusaClaimImage>;
  item: MedusaLineItem;
  item_id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  note: Scalars['String'];
  quantity: Scalars['Float'];
  reason: MedusaClaimReason;
  tags: Array<MedusaClaimTag>;
  updated_at: Scalars['DateTime'];
  variant: MedusaProductVariant;
  variant_id: Scalars['String'];
};

export type MedusaClaimOrder = {
  __typename?: 'MedusaClaimOrder';
  additional_items: Array<MedusaLineItem>;
  canceled_at: Scalars['DateTime'];
  claim_items: Array<MedusaClaimItem>;
  created_at: Scalars['DateTime'];
  deleted_at: Scalars['DateTime'];
  fulfillment_status: MedusaClaimFulfillmentStatus;
  fulfillments: Array<MedusaFulfillment>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  order: MedusaOrder;
  order_id: Scalars['String'];
  payment_status: MedusaClaimPaymentStatus;
  refund_amount: Scalars['Float'];
  return_order: MedusaReturn;
  shipping_address: MedusaAddress;
  shipping_address_id: Scalars['String'];
  shipping_methods: Array<MedusaShippingMethod>;
  type: MedusaClaimType;
  updated_at: Scalars['DateTime'];
};

export enum MedusaClaimPaymentStatus {
  Na = 'NA',
  NotRefunded = 'NOT_REFUNDED',
  Refunded = 'REFUNDED'
}

export enum MedusaClaimReason {
  MissingItem = 'MISSING_ITEM',
  Other = 'OTHER',
  ProductionFailure = 'PRODUCTION_FAILURE',
  WrongItem = 'WRONG_ITEM'
}

export type MedusaClaimTag = {
  __typename?: 'MedusaClaimTag';
  created_at: Scalars['DateTime'];
  deleted_at: Scalars['DateTime'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  updated_at: Scalars['DateTime'];
  value: Scalars['String'];
};

export enum MedusaClaimType {
  Refund = 'REFUND',
  Replace = 'REPLACE'
}

export type MedusaCountry = {
  __typename?: 'MedusaCountry';
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  iso_2?: Maybe<Scalars['String']>;
  iso_3?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  num_code?: Maybe<Scalars['Float']>;
  region?: Maybe<MedusaRegion>;
  region_id?: Maybe<Scalars['String']>;
};

export type MedusaCountryInput = {
  display_name?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  iso_2?: InputMaybe<Scalars['String']>;
  iso_3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  num_code?: InputMaybe<Scalars['Float']>;
  region?: InputMaybe<MedusaRegionInput>;
  region_id?: InputMaybe<Scalars['String']>;
};

export type MedusaCurrency = {
  __typename?: 'MedusaCurrency';
  code: Scalars['String'];
  name: Scalars['String'];
  symbol?: Maybe<Scalars['String']>;
  symbol_native?: Maybe<Scalars['String']>;
};

export type MedusaCurrencyInput = {
  code: Scalars['String'];
  name: Scalars['String'];
  symbol?: InputMaybe<Scalars['String']>;
  symbol_native?: InputMaybe<Scalars['String']>;
};

export type MedusaCustomer = {
  __typename?: 'MedusaCustomer';
  email: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  last_name?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  referral?: Maybe<MedusaCustomerReferral>;
  shipping_addresses?: Maybe<Array<MedusaAddress>>;
};

export type MedusaCustomerReferral = {
  __typename?: 'MedusaCustomerReferral';
  id: Scalars['String'];
  reward_amount: Scalars['Float'];
  template_discount?: Maybe<MedusaCustomerReferral>;
  template_discount_id: Scalars['String'];
};

export type MedusaDiscount = {
  __typename?: 'MedusaDiscount';
  code: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  ends_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  is_disabled: Scalars['Boolean'];
  is_dynamic: Scalars['Boolean'];
  is_recurring?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['JSON']>;
  parent_discount?: Maybe<MedusaDiscount>;
  parent_discount_id?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<MedusaRegion>>;
  rule: MedusaDiscountRule;
  rule_id: Scalars['String'];
  starts_at?: Maybe<Scalars['DateTime']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  usage_count: Scalars['Float'];
  usage_limit?: Maybe<Scalars['Float']>;
  valid_duration?: Maybe<Scalars['String']>;
};

export type MedusaDiscountInput = {
  code: Scalars['String'];
  created_at?: InputMaybe<Scalars['DateTime']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  ends_at?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  is_disabled: Scalars['Boolean'];
  is_dynamic: Scalars['Boolean'];
  is_recurring?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  parent_discount?: InputMaybe<MedusaDiscountInput>;
  parent_discount_id?: InputMaybe<Scalars['String']>;
  regions?: InputMaybe<Array<MedusaRegionInput>>;
  rule: MedusaDiscountRuleInput;
  rule_id: Scalars['String'];
  starts_at?: InputMaybe<Scalars['DateTime']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  usage_count: Scalars['Float'];
  usage_limit?: InputMaybe<Scalars['Float']>;
  valid_duration?: InputMaybe<Scalars['String']>;
};

export type MedusaDiscountRule = {
  __typename?: 'MedusaDiscountRule';
  allocation: MedusaAllocationType;
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  type: MedusaDiscountRuleType;
  updated_at?: Maybe<Scalars['DateTime']>;
  valid_for?: Maybe<Array<MedusaProduct>>;
  value: Scalars['Float'];
};

export type MedusaDiscountRuleInput = {
  allocation: MedusaAllocationType;
  created_at?: InputMaybe<Scalars['DateTime']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  type: MedusaDiscountRuleType;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  valid_for?: InputMaybe<Array<MedusaProductInput>>;
  value: Scalars['Float'];
};

export enum MedusaDiscountRuleType {
  Fixed = 'FIXED',
  FreeShipping = 'FREE_SHIPPING',
  Percentage = 'PERCENTAGE'
}

export type MedusaDraftOrder = {
  __typename?: 'MedusaDraftOrder';
  canceled_at: Scalars['DateTime'];
  cart: MedusaCart;
  cart_id: Scalars['String'];
  completed_at: Scalars['DateTime'];
  created_at: Scalars['DateTime'];
  display_id: Scalars['Float'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  order: MedusaOrder;
  order_id: Scalars['String'];
  status: MedusaDraftOrderStatus;
  updated_at: Scalars['DateTime'];
};

export enum MedusaDraftOrderStatus {
  Completed = 'COMPLETED',
  Open = 'OPEN'
}

export type MedusaFulfillment = {
  __typename?: 'MedusaFulfillment';
  canceled_at: Scalars['DateTime'];
  claim_order: MedusaClaimOrder;
  claim_order_id: Scalars['String'];
  created_at: Scalars['DateTime'];
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  items: Array<MedusaFulfillmentItem>;
  metadata: Scalars['JSON'];
  order: MedusaOrder;
  order_id: Scalars['String'];
  provider: MedusaFulfillmentProvider;
  provider_id: Scalars['String'];
  shipped_at: Scalars['DateTime'];
  swap: MedusaSwap;
  swap_id: Scalars['String'];
  tracking_links: Array<MedusaTrackingLink>;
  tracking_numbers: Array<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type MedusaFulfillmentItem = {
  __typename?: 'MedusaFulfillmentItem';
  fulfillment: MedusaFulfillment;
  fulfillment_id: Scalars['String'];
  item: MedusaLineItem;
  item_id: Scalars['String'];
  quantity: Scalars['Float'];
};

export type MedusaFulfillmentProvider = {
  __typename?: 'MedusaFulfillmentProvider';
  id: Scalars['String'];
  is_installed: Scalars['Boolean'];
};

export type MedusaFulfillmentProviderInput = {
  id: Scalars['String'];
  is_installed: Scalars['Boolean'];
};

export enum MedusaFulfillmentStatus {
  Canceled = 'CANCELED',
  Fulfilled = 'FULFILLED',
  NotFulfilled = 'NOT_FULFILLED',
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  PartiallyReturned = 'PARTIALLY_RETURNED',
  PartiallyShipped = 'PARTIALLY_SHIPPED',
  RequiresAction = 'REQUIRES_ACTION',
  Returned = 'RETURNED',
  Shipped = 'SHIPPED'
}

export type MedusaGiftCard = {
  __typename?: 'MedusaGiftCard';
  balance: Scalars['Float'];
  code: Scalars['String'];
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  ends_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  is_disabled: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  order_id?: Maybe<Scalars['String']>;
  region?: Maybe<MedusaRegion>;
  region_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  value: Scalars['Float'];
};

export type MedusaGiftCardTransaction = {
  __typename?: 'MedusaGiftCardTransaction';
  amount: Scalars['Float'];
  created_at: Scalars['DateTime'];
  gift_card: MedusaGiftCard;
  gift_card_id: Scalars['String'];
  id: Scalars['String'];
  order: MedusaOrder;
  order_id: Scalars['String'];
};

export type MedusaImage = {
  __typename?: 'MedusaImage';
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type MedusaImageInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type MedusaLineItem = {
  __typename?: 'MedusaLineItem';
  allow_discounts: Scalars['Boolean'];
  created_at?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  has_shipping: Scalars['Boolean'];
  id: Scalars['String'];
  is_giftcard: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  product_rating?: Maybe<RatingModel>;
  quantity: Scalars['Float'];
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  unit_price: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
  variant?: Maybe<MedusaProductVariant>;
  variant_id: Scalars['String'];
};

export type MedusaMoneyAmount = {
  __typename?: 'MedusaMoneyAmount';
  amount: Scalars['Float'];
  created_at?: Maybe<Scalars['DateTime']>;
  currency_code: Scalars['String'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  region_id?: Maybe<Scalars['String']>;
  sale_amount?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  variant_id?: Maybe<Scalars['String']>;
};

export type MedusaMoneyAmountInput = {
  amount: Scalars['Float'];
  created_at?: InputMaybe<Scalars['DateTime']>;
  currency_code: Scalars['String'];
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  region_id?: InputMaybe<Scalars['String']>;
  sale_amount?: InputMaybe<Scalars['Float']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  variant_id?: InputMaybe<Scalars['String']>;
};

export type MedusaOrder = {
  __typename?: 'MedusaOrder';
  billing_address: MedusaAddress;
  billing_address_id: Scalars['String'];
  canceled_at?: Maybe<Scalars['DateTime']>;
  cart: MedusaCart;
  cart_id: Scalars['String'];
  claims: Array<MedusaClaimOrder>;
  created_at?: Maybe<Scalars['DateTime']>;
  currency: MedusaCurrency;
  currency_code: Scalars['String'];
  customer: MedusaCustomer;
  customer_id: Scalars['String'];
  discount_total: Scalars['Float'];
  discounts: Array<MedusaDiscount>;
  display_id: Scalars['Float'];
  draft_order: MedusaDraftOrder;
  draft_order_id?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  external_id?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Boolean']>;
  fulfillment_status: MedusaFulfillmentStatus;
  fulfillments: Array<MedusaFulfillment>;
  gift_card_total: Scalars['Float'];
  gift_card_transactions?: Maybe<Array<MedusaGiftCardTransaction>>;
  gift_cards: Array<MedusaGiftCard>;
  id: Scalars['String'];
  items: Array<MedusaLineItem>;
  metadata?: Maybe<Scalars['JSON']>;
  paid_total: Scalars['Float'];
  payment_status: MedusaPaymentStatus;
  payments: Array<MedusaPayment>;
  refundable_amount: Scalars['Float'];
  refunded_total: Scalars['Float'];
  refunds: Array<MedusaRefund>;
  region: MedusaRegion;
  region_id: Scalars['String'];
  returns: Array<MedusaReturn>;
  shipping_address: MedusaAddress;
  shipping_address_id: Scalars['String'];
  shipping_methods: Array<MedusaShippingMethod>;
  shipping_total: Scalars['Float'];
  status: MedusaOrderStatus;
  subtotal: Scalars['Float'];
  swaps?: Maybe<Array<MedusaSwap>>;
  tax_rate: Scalars['Float'];
  tax_total: Scalars['Float'];
  total: Scalars['Float'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export enum MedusaOrderStatus {
  Archived = 'ARCHIVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  RequiresAction = 'REQUIRES_ACTION'
}

export type MedusaPayment = {
  __typename?: 'MedusaPayment';
  amount: Scalars['Float'];
  amount_refunded: Scalars['Float'];
  cart?: Maybe<MedusaCart>;
  cart_id?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  currency: MedusaCurrency;
  currency_code: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  order?: Maybe<MedusaOrder>;
  order_id: Scalars['String'];
  provider_id: Scalars['String'];
  swap: MedusaSwap;
  swap_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type MedusaPaymentMethod = {
  __typename?: 'MedusaPaymentMethod';
  data: StripePaymentMethod;
  provider_id: Scalars['String'];
};

export type MedusaPaymentProvider = {
  __typename?: 'MedusaPaymentProvider';
  id: Scalars['String'];
  is_installed: Scalars['Boolean'];
};

export type MedusaPaymentProviderInput = {
  id: Scalars['String'];
  is_installed: Scalars['Boolean'];
};

export enum MedusaPaymentStatus {
  Awaiting = 'AWAITING',
  Canceled = 'CANCELED',
  Captured = 'CAPTURED',
  NotPaid = 'NOT_PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Refunded = 'REFUNDED',
  RequiresAction = 'REQUIRES_ACTION'
}

export type MedusaProduct = {
  __typename?: 'MedusaProduct';
  collection?: Maybe<MedusaProductCollection>;
  collection_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discountable: Scalars['Boolean'];
  handle?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  hs_code?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  images?: Maybe<Array<MedusaImage>>;
  is_giftcard: Scalars['Boolean'];
  length?: Maybe<Scalars['Float']>;
  material?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  mid_code?: Maybe<Scalars['String']>;
  options?: Maybe<Array<MedusaProductOption>>;
  origin_country?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tags: Array<MedusaProductTag>;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<MedusaProductType>;
  type_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<Array<MedusaProductVariant>>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type MedusaProductCollection = {
  __typename?: 'MedusaProductCollection';
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  handle?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type MedusaProductCollectionInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  handle?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export type MedusaProductInput = {
  collection?: InputMaybe<MedusaProductCollectionInput>;
  collection_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  discountable: Scalars['Boolean'];
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  hs_code?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  images?: InputMaybe<Array<MedusaImageInput>>;
  is_giftcard: Scalars['Boolean'];
  length?: InputMaybe<Scalars['Float']>;
  material?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mid_code?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<MedusaProductOptionInput>>;
  origin_country?: InputMaybe<Scalars['String']>;
  profile_id?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  tags: Array<MedusaProductTagInput>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type?: InputMaybe<MedusaProductTypeInput>;
  type_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  variants?: InputMaybe<Array<MedusaProductVariantInput>>;
  weight?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MedusaProductOption = {
  __typename?: 'MedusaProductOption';
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  product_id: Scalars['String'];
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  values?: Maybe<Array<MedusaProductOptionValue>>;
};

export type MedusaProductOptionInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  product_id: Scalars['String'];
  title: Scalars['String'];
  updated_at?: InputMaybe<Scalars['DateTime']>;
  values?: InputMaybe<Array<MedusaProductOptionValueInput>>;
};

export type MedusaProductOptionValue = {
  __typename?: 'MedusaProductOptionValue';
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  option_id: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  value: Scalars['String'];
  variant_id: Scalars['String'];
};

export type MedusaProductOptionValueInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  option_id: Scalars['String'];
  updated_at?: InputMaybe<Scalars['DateTime']>;
  value: Scalars['String'];
  variant_id: Scalars['String'];
};

export type MedusaProductTag = {
  __typename?: 'MedusaProductTag';
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type MedusaProductTagInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['String']>;
};

export type MedusaProductType = {
  __typename?: 'MedusaProductType';
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type MedusaProductTypeInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['String']>;
};

export type MedusaProductVariant = {
  __typename?: 'MedusaProductVariant';
  allow_backorder?: Maybe<Scalars['Boolean']>;
  barcode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  deleted_at?: Maybe<Scalars['DateTime']>;
  dietary_information?: Maybe<VariantDietaryInformation>;
  ean?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  hs_code?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inventory_quantity?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  manage_inventory?: Maybe<Scalars['Boolean']>;
  material?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  mid_code?: Maybe<Scalars['String']>;
  options?: Maybe<Array<MedusaProductOptionValue>>;
  origin_country?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<MedusaMoneyAmount>>;
  product?: Maybe<MedusaProduct>;
  product_id: Scalars['String'];
  sku: Scalars['String'];
  title: Scalars['String'];
  upc?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  variant_preference?: Maybe<VariantPreference>;
  variant_rank?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type MedusaProductVariantInput = {
  allow_backorder?: InputMaybe<Scalars['Boolean']>;
  barcode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  ean?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  hs_code?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  inventory_quantity?: InputMaybe<Scalars['Float']>;
  length?: InputMaybe<Scalars['Float']>;
  manage_inventory?: InputMaybe<Scalars['Boolean']>;
  material?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mid_code?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<MedusaProductOptionValueInput>>;
  origin_country?: InputMaybe<Scalars['String']>;
  prices?: InputMaybe<Array<MedusaMoneyAmountInput>>;
  product_id: Scalars['String'];
  sku: Scalars['String'];
  title: Scalars['String'];
  upc?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
  variant_preference?: InputMaybe<VariantPreferenceInput>;
  variant_rank?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MedusaRefund = {
  __typename?: 'MedusaRefund';
  amount: Scalars['Float'];
  created_at: Scalars['DateTime'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  note: Scalars['String'];
  order: MedusaOrder;
  order_id?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type MedusaRegion = {
  __typename?: 'MedusaRegion';
  countries?: Maybe<Array<MedusaCountry>>;
  created_at?: Maybe<Scalars['DateTime']>;
  currency: MedusaCurrency;
  currency_code: Scalars['String'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  fulfillment_providers?: Maybe<Array<MedusaFulfillmentProvider>>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  payment_providers?: Maybe<Array<MedusaPaymentProvider>>;
  tax_code?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['Float']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type MedusaRegionInput = {
  countries?: InputMaybe<Array<MedusaCountryInput>>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  currency: MedusaCurrencyInput;
  currency_code: Scalars['String'];
  deleted_at?: InputMaybe<Scalars['DateTime']>;
  fulfillment_providers?: InputMaybe<Array<MedusaFulfillmentProviderInput>>;
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  payment_providers?: InputMaybe<Array<MedusaPaymentProviderInput>>;
  tax_code?: InputMaybe<Scalars['String']>;
  tax_rate?: InputMaybe<Scalars['Float']>;
  updated_at?: InputMaybe<Scalars['DateTime']>;
};

export enum MedusaRequirementType {
  MaxSubtotal = 'MAX_SUBTOTAL',
  MinSubtotal = 'MIN_SUBTOTAL'
}

export type MedusaReturn = {
  __typename?: 'MedusaReturn';
  claim_order: MedusaClaimOrder;
  claim_order_id: Scalars['String'];
  created_at: Scalars['DateTime'];
  id: Scalars['String'];
  items: Array<MedusaReturnItem>;
  metadata: Scalars['JSON'];
  order: MedusaOrder;
  order_id: Scalars['String'];
  received_at: Scalars['DateTime'];
  refund_amount: Scalars['Float'];
  shipping_data?: Maybe<Scalars['JSON']>;
  shipping_method: MedusaShippingMethod;
  status: MedusaReturnStatus;
  swap: MedusaSwap;
  swap_id: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type MedusaReturnItem = {
  __typename?: 'MedusaReturnItem';
  is_requested: Scalars['Boolean'];
  item: MedusaLineItem;
  item_id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  note: Scalars['String'];
  quantity: Scalars['Float'];
  reason: MedusaReturnReason;
  reason_id: Scalars['String'];
  received_quantity: Scalars['Float'];
  requested_quantity: Scalars['Float'];
  return_id: Scalars['String'];
  return_order: MedusaReturn;
};

export type MedusaReturnReason = {
  __typename?: 'MedusaReturnReason';
  created_at: Scalars['DateTime'];
  deleted_at: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  parent_return_reason: MedusaReturnReason;
  parent_return_reason_id: Scalars['String'];
  return_reason_children: Array<MedusaReturnReason>;
  updated_at: Scalars['DateTime'];
  value: Scalars['String'];
};

export enum MedusaReturnStatus {
  Canceled = 'CANCELED',
  Received = 'RECEIVED',
  Requested = 'REQUESTED',
  RequiresAction = 'REQUIRES_ACTION'
}

export type MedusaShippingMethod = {
  __typename?: 'MedusaShippingMethod';
  cart: MedusaCart;
  cart_id: Scalars['String'];
  claim_order: MedusaClaimOrder;
  claim_order_id: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  order: MedusaOrder;
  order_id: Scalars['String'];
  price: Scalars['Float'];
  return_id: Scalars['String'];
  return_order: MedusaReturn;
  shipping_option: MedusaShippingOption;
  shipping_option_id: Scalars['String'];
  swap: MedusaSwap;
  swap_id: Scalars['String'];
};

export type MedusaShippingOption = {
  __typename?: 'MedusaShippingOption';
  admin_only: Scalars['Boolean'];
  amount: Scalars['Float'];
  created_at: Scalars['DateTime'];
  data?: Maybe<Scalars['JSON']>;
  deleted_at: Scalars['DateTime'];
  id: Scalars['String'];
  is_return: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  price_type: MedusaShippingOptionPriceType;
  profile: MedusaShippingProfile;
  profile_id: Scalars['String'];
  provider: MedusaFulfillmentProvider;
  provider_id: Scalars['String'];
  region: MedusaRegion;
  region_id: Scalars['String'];
  requirements: Array<MedusaShippingOptionRequirement>;
  updated_at: Scalars['DateTime'];
};

export enum MedusaShippingOptionPriceType {
  Calculated = 'CALCULATED',
  FlatRate = 'FLAT_RATE'
}

export type MedusaShippingOptionRequirement = {
  __typename?: 'MedusaShippingOptionRequirement';
  amount: Scalars['Float'];
  deleted_at: Scalars['DateTime'];
  id: Scalars['String'];
  shipping_option: MedusaShippingOption;
  shipping_option_id: Scalars['String'];
  type: MedusaRequirementType;
};

export type MedusaShippingProfile = {
  __typename?: 'MedusaShippingProfile';
  created_at: Scalars['DateTime'];
  deleted_at: Scalars['DateTime'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  products: Array<MedusaProduct>;
  shipping_options: Array<MedusaShippingOption>;
  type: MedusaShippingProfileType;
  updated_at: Scalars['DateTime'];
};

export enum MedusaShippingProfileType {
  Custom = 'CUSTOM',
  Default = 'DEFAULT',
  GiftCard = 'GIFT_CARD'
}

export type MedusaSwap = {
  __typename?: 'MedusaSwap';
  additional_items: Array<MedusaLineItem>;
  canceled_at: Scalars['DateTime'];
  cart: MedusaCart;
  cart_id: Scalars['String'];
  confirmed_at: Scalars['DateTime'];
  created_at: Scalars['DateTime'];
  deleted_at: Scalars['DateTime'];
  difference_due: Scalars['Float'];
  fulfillment_status: MedusaSwapFulfillmentStatus;
  fulfillments: Array<MedusaFulfillment>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  order: MedusaOrder;
  order_id: Scalars['String'];
  payment: MedusaPayment;
  return_order: MedusaReturn;
  shipping_address: MedusaAddress;
  shipping_address_id: Scalars['String'];
  shipping_methods: Array<MedusaShippingMethod>;
  updated_at: Scalars['DateTime'];
};

export enum MedusaSwapFulfillmentStatus {
  Canceled = 'CANCELED',
  Fulfilled = 'FULFILLED',
  NotFulfilled = 'NOT_FULFILLED',
  RequiresAction = 'REQUIRES_ACTION',
  Shipped = 'SHIPPED'
}

export type MedusaTrackingLink = {
  __typename?: 'MedusaTrackingLink';
  created_at: Scalars['DateTime'];
  deleted_at: Scalars['DateTime'];
  fulfillment: MedusaFulfillment;
  fulfillment_id: Scalars['String'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  tracking_number: Scalars['String'];
  updated_at: Scalars['DateTime'];
  url: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addDiscountCodeToCart: Array<MedusaDiscount>;
  addReturningDiscountCodeToCart: MedusaCart;
  cancelSubscription: SubscriptionModel;
  createCancellationFeedback: CancellationFeedback;
  createStripeSetupIntent: StripeSetupIntent;
  createSubscription: SubscriptionModel;
  createUserShippingAddress: StandardAddress;
  deleteUserShippingAddress: Scalars['Boolean'];
  detachUserPaymentMethod: Scalars['Boolean'];
  finishOnboarding: SubscriptionModel;
  finishRegistration: LoginResponse;
  forgotPassword: Scalars['Boolean'];
  login: LoginResponse;
  postalCodeAllowed: Scalars['Boolean'];
  register: RegisterResponse;
  rerunSubscriptionTransactions: SubscriptionModel;
  resetPassword: LoginResponse;
  restartSubscription: SubscriptionModel;
  saveFavoritePreference: VariantPreference;
  saveNeverPreference: VariantPreference;
  saveProductRating: RatingModel;
  send_email_preview: Scalars['Boolean'];
  setDefaultUserPaymentMethod: StripePaymentMethod;
  setDefaultUserShippingAddress: StandardAddress;
  setPassword: User;
  startSubscription: SubscriptionModel;
  testError: Scalars['Boolean'];
  unpauseSubscription: SubscriptionModel;
  updateCurrentOrderLineItem: SubscriptionOrder;
  updateDraftOrder: MedusaDraftOrder;
  updatePreferences: MealPreferencesModel;
  updateSubscription: SubscriptionModel;
  updateSubscriptionFrequency: SubscriptionModel;
  updateSubscriptionOrder: SubscriptionOrder;
  updateUser: User;
  updateUserPaymentMethod: StripePaymentMethod;
  updateUserShippingAddress: StandardAddress;
  updateUserStripeCustomer: StripeCustomer;
  upsertExtraLineItem: SubscriptionOrder;
};

export type MutationAddDiscountCodeToCartArgs = {
  input: AddDiscountCodeInput;
};

export type MutationCreateCancellationFeedbackArgs = {
  input: CancellationFeedbackInput;
};

export type MutationCreateSubscriptionArgs = {
  input: CreateUserSubscriptionInput;
};

export type MutationCreateUserShippingAddressArgs = {
  createAddressInput: CreateAddressInput;
};

export type MutationDeleteUserShippingAddressArgs = {
  addressId: Scalars['String'];
};

export type MutationDetachUserPaymentMethodArgs = {
  paymentMethodId: Scalars['String'];
};

export type MutationFinishOnboardingArgs = {
  finishOnboardingInput: FinishOnboardingInput;
};

export type MutationFinishRegistrationArgs = {
  validateAccountInput: ValidateAccountInput;
};

export type MutationForgotPasswordArgs = {
  forgotPasswordInput: ForgotPasswordInput;
};

export type MutationLoginArgs = {
  loginInput: LoginInput;
};

export type MutationPostalCodeAllowedArgs = {
  postal_code: Scalars['String'];
};

export type MutationRegisterArgs = {
  createUserInput: CreateUserInput;
};

export type MutationResetPasswordArgs = {
  resetPasswordInput: ResetPasswordInput;
};

export type MutationSaveFavoritePreferenceArgs = {
  input: SaveFavoritePreferenceInput;
};

export type MutationSaveNeverPreferenceArgs = {
  input: SaveNeverPreferenceInput;
};

export type MutationSaveProductRatingArgs = {
  input: SaveProductRatingInput;
};

export type MutationSend_Email_PreviewArgs = {
  templateName: Scalars['String'];
  to: Scalars['String'];
};

export type MutationSetDefaultUserPaymentMethodArgs = {
  paymentMethodId: Scalars['String'];
};

export type MutationSetDefaultUserShippingAddressArgs = {
  addressId: Scalars['String'];
};

export type MutationSetPasswordArgs = {
  setPasswordInput: SetPasswordInput;
};

export type MutationUpdateCurrentOrderLineItemArgs = {
  input: UpdateLineItemInput;
};

export type MutationUpdateDraftOrderArgs = {
  input: UpdateDraftOrderInput;
};

export type MutationUpdatePreferencesArgs = {
  mealPreferencesInput: MealPreferencesInput;
};

export type MutationUpdateSubscriptionArgs = {
  input: CreateUserSubscriptionInput;
};

export type MutationUpdateSubscriptionFrequencyArgs = {
  input: UpdateSubscriptionFrequencyInput;
};

export type MutationUpdateSubscriptionOrderArgs = {
  updateSubscriptionOrderInput: UpdateSubscriptionOrderInput;
};

export type MutationUpdateUserArgs = {
  userInput: UpdateUserInput;
};

export type MutationUpdateUserPaymentMethodArgs = {
  updatePaymentMethodInput: StripePaymentMethodInput;
};

export type MutationUpdateUserShippingAddressArgs = {
  updateAddressInput: UpdateAddressInput;
};

export type MutationUpdateUserStripeCustomerArgs = {
  updateUserStripeCustomerInput: StripeCustomerInput;
};

export type MutationUpsertExtraLineItemArgs = {
  input: UpsertExtraLineItemInput;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentProcessing = 'PAYMENT_PROCESSING',
  Refunded = 'REFUNDED',
  WaitingFulfillment = 'WAITING_FULFILLMENT'
}

export type Query = {
  __typename?: 'Query';
  customerOrders: Array<MedusaOrder>;
  email_preview: MjmlEmailPreview;
  fetchDiscount: MedusaDiscount;
  me: User;
  orderedMeals: Array<MedusaProductVariant>;
  payment_methods: Array<MedusaPaymentMethod>;
  previewDraftOrder: MedusaDraftOrder;
  productVariant: MedusaProductVariant;
  productVariants: Array<MedusaProductVariant>;
  products: Array<MedusaProduct>;
  variantPreference: VariantPreference;
};

export type QueryEmail_PreviewArgs = {
  templateName: Scalars['String'];
};

export type QueryFetchDiscountArgs = {
  input: RetrieveDiscountInput;
};

export type QueryOrderedMealsArgs = {
  currentSubscriptionOrderId?: InputMaybe<Scalars['String']>;
  filterPremiums?: InputMaybe<Scalars['Boolean']>;
};

export type QueryPreviewDraftOrderArgs = {
  input: CreateUserSubscriptionInput;
};

export type QueryProductVariantArgs = {
  id: Scalars['String'];
};

export type QueryProductVariantsArgs = {
  collection_title?: InputMaybe<Scalars['String']>;
  sku_filter?: InputMaybe<Scalars['String']>;
};

export type QueryProductsArgs = {
  collection_title?: InputMaybe<Scalars['String']>;
};

export type QueryVariantPreferenceArgs = {
  variant_id: Scalars['String'];
};

export type RatingModel = {
  __typename?: 'RatingModel';
  created_at?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  medusa_line_item_id: Scalars['String'];
  medusa_order_id: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  product_variant_id: Scalars['String'];
  rating?: Maybe<Scalars['Float']>;
  user_id: Scalars['String'];
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  JWT: Scalars['String'];
  hashed_password: Scalars['String'];
};

export type ResetPasswordInput = {
  forgot_password_token: Scalars['String'];
  new_password: Scalars['String'];
};

export type RetrieveDiscountInput = {
  id: Scalars['String'];
};

export type SaveFavoritePreferenceInput = {
  favorite: Scalars['Boolean'];
  product_variant_id: Scalars['String'];
};

export type SaveNeverPreferenceInput = {
  never: Scalars['Boolean'];
  product_variant_id: Scalars['String'];
};

export type SaveProductRatingInput = {
  medusa_line_item_id: Scalars['String'];
  medusa_order_id: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Float']>;
};

export type SetPasswordInput = {
  current_password?: InputMaybe<Scalars['String']>;
  new_password?: InputMaybe<Scalars['String']>;
};

export type StandardAddress = {
  __typename?: 'StandardAddress';
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  customer_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  id: Scalars['String'];
  is_default?: Maybe<Scalars['Boolean']>;
  last_name: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  phone?: Maybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
};

export type StripeAddress = {
  __typename?: 'StripeAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
};

export type StripeAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
};

export type StripeBillingDetails = {
  __typename?: 'StripeBillingDetails';
  address?: Maybe<StripeAddress>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type StripeBillingDetailsInput = {
  address?: InputMaybe<StripeAddressInput>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type StripeCustomField = {
  __typename?: 'StripeCustomField';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  address?: Maybe<StripeAddress>;
  balance?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  default_source?: Maybe<Scalars['String']>;
  delinquent?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoice_prefix?: Maybe<Scalars['String']>;
  invoice_settings?: Maybe<StripeCustomerInvoiceSettings>;
  livemode?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  object: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  shipping?: Maybe<StripeCustomerShippingDetails>;
};

export type StripeCustomerInput = {
  default_source?: InputMaybe<Scalars['String']>;
  invoice_settings?: InputMaybe<StripeCustomerInvoiceSettingsInput>;
  shipping?: InputMaybe<StripeCustomerShippingDetailsInput>;
};

export type StripeCustomerInvoiceSettings = {
  __typename?: 'StripeCustomerInvoiceSettings';
  custom_fields?: Maybe<Array<StripeCustomField>>;
  default_payment_method?: Maybe<Scalars['String']>;
};

export type StripeCustomerInvoiceSettingsInput = {
  default_payment_method?: InputMaybe<Scalars['String']>;
};

export type StripeCustomerShippingDetails = {
  __typename?: 'StripeCustomerShippingDetails';
  address?: Maybe<StripeAddress>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type StripeCustomerShippingDetailsInput = {
  address?: InputMaybe<StripeAddressInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  billing_details: StripeBillingDetails;
  card: StripePaymentMethodCard;
  created?: Maybe<Scalars['Int']>;
  customer_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_default?: Maybe<Scalars['Boolean']>;
  livemode?: Maybe<Scalars['Boolean']>;
  object?: Maybe<Scalars['String']>;
};

export type StripePaymentMethodCard = {
  __typename?: 'StripePaymentMethodCard';
  brand: Scalars['String'];
  country: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  exp_month: Scalars['Int'];
  exp_year: Scalars['Int'];
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<Scalars['String']>;
  iin?: Maybe<Scalars['String']>;
  issuer?: Maybe<Scalars['String']>;
  last4: Scalars['String'];
};

export type StripePaymentMethodCardInput = {
  exp_month: Scalars['Int'];
  exp_year: Scalars['Int'];
};

export type StripePaymentMethodInput = {
  billing_details: StripeBillingDetailsInput;
  card: StripePaymentMethodCardInput;
  id: Scalars['String'];
  is_default?: InputMaybe<Scalars['Boolean']>;
};

export type StripeSetupIntent = {
  __typename?: 'StripeSetupIntent';
  client_secret: Scalars['String'];
  created: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['String'];
  livemode: Scalars['Boolean'];
  object: Scalars['String'];
  usage: Scalars['String'];
};

export enum SubscriptionFrequency {
  FourWeeks = 'FOUR_WEEKS',
  OneWeek = 'ONE_WEEK',
  ThreeWeeks = 'THREE_WEEKS',
  TwoWeeks = 'TWO_WEEKS'
}

export type SubscriptionItemModel = {
  __typename?: 'SubscriptionItemModel';
  created_at: Scalars['DateTime'];
  id: Scalars['String'];
  product_variant?: Maybe<MedusaProductVariant>;
  product_variant_id: Scalars['String'];
  quantity: Scalars['Float'];
  subscription_id: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type SubscriptionModel = {
  __typename?: 'SubscriptionModel';
  created_at: Scalars['DateTime'];
  current_order?: Maybe<SubscriptionOrder>;
  end_date?: Maybe<Scalars['DateTime']>;
  frequency: SubscriptionFrequency;
  id: Scalars['String'];
  medusa_shipping_address_id?: Maybe<Scalars['String']>;
  product_variant?: Maybe<MedusaProductVariant>;
  product_variant_id: Scalars['String'];
  promo_code?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['DateTime']>;
  status: SubscriptionStatus;
  status_reason?: Maybe<Scalars['String']>;
  subscription_items?: Maybe<Array<SubscriptionItemModel>>;
  upcoming_orders?: Maybe<Array<SubscriptionOrder>>;
  updated_at: Scalars['DateTime'];
  user_id: Scalars['String'];
};

export type SubscriptionOrder = {
  __typename?: 'SubscriptionOrder';
  complete_order_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  id: Scalars['String'];
  medusa_cart?: Maybe<MedusaCart>;
  medusa_cart_id?: Maybe<Scalars['String']>;
  processed_at?: Maybe<Scalars['DateTime']>;
  skip: Scalars['Boolean'];
  status: OrderStatus;
  subscription_id: Scalars['String'];
  updated_at: Scalars['DateTime'];
  week?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Onboarding = 'ONBOARDING',
  Paused = 'PAUSED'
}

export type UpdateAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  is_default?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type UpdateDraftOrderInput = {
  billing_address?: InputMaybe<MedusaAddressInput>;
  customer_id?: InputMaybe<Scalars['String']>;
  discounts?: InputMaybe<Array<MedusaDiscountInput>>;
  email?: InputMaybe<Scalars['String']>;
  region_id?: InputMaybe<Scalars['String']>;
  shipping_address?: InputMaybe<MedusaAddressInput>;
};

export type UpdateLineItemInput = {
  id: Scalars['String'];
  variant_id: Scalars['String'];
};

export type UpdateSubscriptionFrequencyInput = {
  frequency: SubscriptionFrequency;
};

export type UpdateSubscriptionOrderInput = {
  id: Scalars['String'];
  skip: Scalars['Boolean'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  meal_preferences?: InputMaybe<MealPreferencesInput>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
};

export type UpsertExtraLineItemInput = {
  product_variant_id: Scalars['String'];
  quantity: Scalars['Float'];
};

export type User = {
  __typename?: 'User';
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  email_verified: Scalars['Boolean'];
  facebook_oauth_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  google_oauth_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  impersonating: Scalars['Boolean'];
  is_active: Scalars['Boolean'];
  last_name?: Maybe<Scalars['String']>;
  meal_preferences?: Maybe<MealPreferencesModel>;
  medusa_customer: MedusaCustomer;
  medusa_customer_id: Scalars['String'];
  medusa_shipping_address_id?: Maybe<Scalars['String']>;
  payment_methods?: Maybe<Array<StripePaymentMethod>>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  shipping_addresses?: Maybe<Array<StandardAddress>>;
  stripe_customer: StripeCustomer;
  stripe_customer_id: Scalars['String'];
  subscription?: Maybe<SubscriptionModel>;
  updated_at: Scalars['DateTime'];
};

export type ValidateAccountInput = {
  jwt: Scalars['String'];
  otp: Scalars['String'];
};

export type VariantDietaryInformation = {
  __typename?: 'VariantDietaryInformation';
  allergens: Array<Allergen>;
  diets: Array<DietType>;
  ingredients?: Maybe<Array<Scalars['String']>>;
  nutrients: DietaryNutrients;
};

export type VariantPreference = {
  __typename?: 'VariantPreference';
  created_at?: Maybe<Scalars['DateTime']>;
  favorite?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  never?: Maybe<Scalars['Boolean']>;
  product_variant_id: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
  user_id: Scalars['String'];
};

export type VariantPreferenceInput = {
  created_at?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  never?: InputMaybe<Scalars['Boolean']>;
  product_variant_id: Scalars['String'];
  updated_at?: InputMaybe<Scalars['DateTime']>;
  user_id: Scalars['String'];
};

export type CurrentCartQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentCartQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    subscription?: {
      __typename?: 'SubscriptionModel';
      id: string;
      user_id: string;
      start_date?: any | null;
      end_date?: any | null;
      frequency: SubscriptionFrequency;
      product_variant_id: string;
      status: SubscriptionStatus;
      status_reason?: string | null;
      created_at: any;
      updated_at: any;
      product_variant?: {
        __typename?: 'MedusaProductVariant';
        id: string;
        title: string;
        sku: string;
        product_id: string;
        metadata?: any | null;
        options?: Array<{
          __typename?: 'MedusaProductOptionValue';
          id: string;
          value: string;
          option_id: string;
          variant_id: string;
        }> | null;
        variant_preference?: {
          __typename?: 'VariantPreference';
          id: string;
          user_id: string;
          product_variant_id: string;
          favorite?: boolean | null;
          never?: boolean | null;
        } | null;
        dietary_information?: {
          __typename?: 'VariantDietaryInformation';
          allergens: Array<Allergen>;
          diets: Array<DietType>;
          ingredients?: Array<string> | null;
          nutrients: {
            __typename?: 'DietaryNutrients';
            calories: number;
            carbohydrate: number;
            cholesterol: number;
            fat: number;
            fat_saturated: number;
            fat_trans: number;
            fiber: number;
            uncounted_fiber: number;
            sugar: number;
            added_sugar: number;
            sugar_alcohol: number;
            sodium: number;
            calcium: number;
            iron: number;
            vitamin_c: number;
            vitamin_a_IU: number;
            potassium: number;
            fat_monounsaturated: number;
            fat_polyunsaturated: number;
            magnesium: number;
            phosphorus: number;
            zinc: number;
            copper: number;
            manganese: number;
            selenium: number;
            thiamin: number;
            riboflavin: number;
            niacin: number;
            vitamin_b6: number;
            folate: number;
            folic_acid: number;
            chlorine: number;
            vitamin_b12: number;
            vitamin_e: number;
            vitamin_d_IU: number;
            vitamin_k: number;
            protein: number;
          };
        } | null;
        prices?: Array<{
          __typename?: 'MedusaMoneyAmount';
          id: string;
          currency_code: string;
          amount: number;
          sale_amount?: number | null;
        }> | null;
        product?: {
          __typename?: 'MedusaProduct';
          id: string;
          title: string;
          description?: string | null;
          discountable: boolean;
          is_giftcard: boolean;
          handle?: string | null;
          thumbnail?: string | null;
          tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
          variants?: Array<{
            __typename?: 'MedusaProductVariant';
            id: string;
            product_id: string;
            sku: string;
            title: string;
          }> | null;
          collection?: {
            __typename?: 'MedusaProductCollection';
            id: string;
            title?: string | null;
            handle?: string | null;
          } | null;
        } | null;
      } | null;
      current_order?: {
        __typename?: 'SubscriptionOrder';
        id: string;
        complete_order_at?: any | null;
        created_at: any;
        medusa_cart_id?: string | null;
        processed_at?: any | null;
        skip: boolean;
        status: OrderStatus;
        subscription_id: string;
        updated_at: any;
        week?: number | null;
        year?: number | null;
        medusa_cart?: {
          __typename?: 'MedusaCart';
          id: string;
          email?: string | null;
          billing_address_id?: string | null;
          shipping_address_id?: string | null;
          region_id: string;
          customer_id?: string | null;
          type: MedusaCartType;
          completed_at?: any | null;
          payment_authorized_at?: any | null;
          created_at?: any | null;
          updated_at?: any | null;
          deleted_at?: any | null;
          metadata?: any | null;
          shipping_total?: number | null;
          discount_total?: number | null;
          tax_total?: number | null;
          total?: number | null;
          subtotal?: number | null;
          gift_card_total?: number | null;
          items: Array<{
            __typename?: 'MedusaLineItem';
            id: string;
            description?: string | null;
            title?: string | null;
            quantity: number;
            allow_discounts: boolean;
            has_shipping: boolean;
            unit_price: number;
            variant_id: string;
            is_giftcard: boolean;
            thumbnail?: string | null;
            metadata?: any | null;
            created_at?: any | null;
            variant?: {
              __typename?: 'MedusaProductVariant';
              id: string;
              title: string;
              sku: string;
              product_id: string;
              metadata?: any | null;
              options?: Array<{
                __typename?: 'MedusaProductOptionValue';
                id: string;
                value: string;
                option_id: string;
                variant_id: string;
              }> | null;
              variant_preference?: {
                __typename?: 'VariantPreference';
                id: string;
                user_id: string;
                product_variant_id: string;
                favorite?: boolean | null;
                never?: boolean | null;
              } | null;
              dietary_information?: {
                __typename?: 'VariantDietaryInformation';
                allergens: Array<Allergen>;
                diets: Array<DietType>;
                ingredients?: Array<string> | null;
                nutrients: {
                  __typename?: 'DietaryNutrients';
                  calories: number;
                  carbohydrate: number;
                  cholesterol: number;
                  fat: number;
                  fat_saturated: number;
                  fat_trans: number;
                  fiber: number;
                  uncounted_fiber: number;
                  sugar: number;
                  added_sugar: number;
                  sugar_alcohol: number;
                  sodium: number;
                  calcium: number;
                  iron: number;
                  vitamin_c: number;
                  vitamin_a_IU: number;
                  potassium: number;
                  fat_monounsaturated: number;
                  fat_polyunsaturated: number;
                  magnesium: number;
                  phosphorus: number;
                  zinc: number;
                  copper: number;
                  manganese: number;
                  selenium: number;
                  thiamin: number;
                  riboflavin: number;
                  niacin: number;
                  vitamin_b6: number;
                  folate: number;
                  folic_acid: number;
                  chlorine: number;
                  vitamin_b12: number;
                  vitamin_e: number;
                  vitamin_d_IU: number;
                  vitamin_k: number;
                  protein: number;
                };
              } | null;
              prices?: Array<{
                __typename?: 'MedusaMoneyAmount';
                id: string;
                currency_code: string;
                amount: number;
                sale_amount?: number | null;
              }> | null;
              product?: {
                __typename?: 'MedusaProduct';
                id: string;
                title: string;
                description?: string | null;
                discountable: boolean;
                is_giftcard: boolean;
                handle?: string | null;
                thumbnail?: string | null;
                tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
                variants?: Array<{
                  __typename?: 'MedusaProductVariant';
                  id: string;
                  product_id: string;
                  sku: string;
                  title: string;
                }> | null;
                collection?: {
                  __typename?: 'MedusaProductCollection';
                  id: string;
                  title?: string | null;
                  handle?: string | null;
                } | null;
              } | null;
            } | null;
          }>;
          discounts?: Array<{
            __typename?: 'MedusaDiscount';
            id: string;
            code: string;
            is_dynamic: boolean;
            rule_id: string;
            is_disabled: boolean;
            usage_limit?: number | null;
            usage_count: number;
            is_recurring?: boolean | null;
            rule: {
              __typename?: 'MedusaDiscountRule';
              id: string;
              description: string;
              type: MedusaDiscountRuleType;
              value: number;
              allocation: MedusaAllocationType;
            };
          }> | null;
          gift_cards?: Array<{
            __typename?: 'MedusaGiftCard';
            id: string;
            code: string;
            balance: number;
            value: number;
            is_disabled: boolean;
          }> | null;
        } | null;
      } | null;
      upcoming_orders?: Array<{
        __typename?: 'SubscriptionOrder';
        id: string;
        complete_order_at?: any | null;
        created_at: any;
        medusa_cart_id?: string | null;
        processed_at?: any | null;
        skip: boolean;
        status: OrderStatus;
        subscription_id: string;
        updated_at: any;
        week?: number | null;
        year?: number | null;
      }> | null;
    } | null;
  };
};

export type AddDiscountCodeToCartMutationVariables = Exact<{
  addDiscountCodeInput: AddDiscountCodeInput;
}>;

export type AddDiscountCodeToCartMutation = {
  __typename?: 'Mutation';
  addDiscountCodeToCart: Array<{
    __typename?: 'MedusaDiscount';
    id: string;
    code: string;
    is_dynamic: boolean;
    rule_id: string;
    is_disabled: boolean;
    usage_limit?: number | null;
    usage_count: number;
    is_recurring?: boolean | null;
    rule: {
      __typename?: 'MedusaDiscountRule';
      id: string;
      description: string;
      type: MedusaDiscountRuleType;
      value: number;
      allocation: MedusaAllocationType;
    };
  }>;
};

export type PreviewDraftOrderQueryVariables = Exact<{
  input: CreateUserSubscriptionInput;
}>;

export type PreviewDraftOrderQuery = {
  __typename?: 'Query';
  previewDraftOrder: {
    __typename?: 'MedusaDraftOrder';
    id: string;
    cart: {
      __typename?: 'MedusaCart';
      id: string;
      email?: string | null;
      billing_address_id?: string | null;
      shipping_address_id?: string | null;
      region_id: string;
      customer_id?: string | null;
      type: MedusaCartType;
      completed_at?: any | null;
      payment_authorized_at?: any | null;
      created_at?: any | null;
      updated_at?: any | null;
      deleted_at?: any | null;
      metadata?: any | null;
      shipping_total?: number | null;
      discount_total?: number | null;
      tax_total?: number | null;
      total?: number | null;
      subtotal?: number | null;
      gift_card_total?: number | null;
      items: Array<{
        __typename?: 'MedusaLineItem';
        id: string;
        description?: string | null;
        title?: string | null;
        quantity: number;
        allow_discounts: boolean;
        has_shipping: boolean;
        unit_price: number;
        variant_id: string;
        is_giftcard: boolean;
        thumbnail?: string | null;
        metadata?: any | null;
        created_at?: any | null;
        variant?: {
          __typename?: 'MedusaProductVariant';
          id: string;
          title: string;
          sku: string;
          product_id: string;
          metadata?: any | null;
          options?: Array<{
            __typename?: 'MedusaProductOptionValue';
            id: string;
            value: string;
            option_id: string;
            variant_id: string;
          }> | null;
          variant_preference?: {
            __typename?: 'VariantPreference';
            id: string;
            user_id: string;
            product_variant_id: string;
            favorite?: boolean | null;
            never?: boolean | null;
          } | null;
          dietary_information?: {
            __typename?: 'VariantDietaryInformation';
            allergens: Array<Allergen>;
            diets: Array<DietType>;
            ingredients?: Array<string> | null;
            nutrients: {
              __typename?: 'DietaryNutrients';
              calories: number;
              carbohydrate: number;
              cholesterol: number;
              fat: number;
              fat_saturated: number;
              fat_trans: number;
              fiber: number;
              uncounted_fiber: number;
              sugar: number;
              added_sugar: number;
              sugar_alcohol: number;
              sodium: number;
              calcium: number;
              iron: number;
              vitamin_c: number;
              vitamin_a_IU: number;
              potassium: number;
              fat_monounsaturated: number;
              fat_polyunsaturated: number;
              magnesium: number;
              phosphorus: number;
              zinc: number;
              copper: number;
              manganese: number;
              selenium: number;
              thiamin: number;
              riboflavin: number;
              niacin: number;
              vitamin_b6: number;
              folate: number;
              folic_acid: number;
              chlorine: number;
              vitamin_b12: number;
              vitamin_e: number;
              vitamin_d_IU: number;
              vitamin_k: number;
              protein: number;
            };
          } | null;
          prices?: Array<{
            __typename?: 'MedusaMoneyAmount';
            id: string;
            currency_code: string;
            amount: number;
            sale_amount?: number | null;
          }> | null;
          product?: {
            __typename?: 'MedusaProduct';
            id: string;
            title: string;
            description?: string | null;
            discountable: boolean;
            is_giftcard: boolean;
            handle?: string | null;
            thumbnail?: string | null;
            tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
            variants?: Array<{
              __typename?: 'MedusaProductVariant';
              id: string;
              product_id: string;
              sku: string;
              title: string;
            }> | null;
            collection?: {
              __typename?: 'MedusaProductCollection';
              id: string;
              title?: string | null;
              handle?: string | null;
            } | null;
          } | null;
        } | null;
      }>;
      discounts?: Array<{
        __typename?: 'MedusaDiscount';
        id: string;
        code: string;
        is_dynamic: boolean;
        rule_id: string;
        is_disabled: boolean;
        usage_limit?: number | null;
        usage_count: number;
        is_recurring?: boolean | null;
        rule: {
          __typename?: 'MedusaDiscountRule';
          id: string;
          description: string;
          type: MedusaDiscountRuleType;
          value: number;
          allocation: MedusaAllocationType;
        };
      }> | null;
    };
  };
};

export type UpdateDraftOrderMutationVariables = Exact<{
  input: UpdateDraftOrderInput;
}>;

export type UpdateDraftOrderMutation = {
  __typename?: 'Mutation';
  updateDraftOrder: {
    __typename?: 'MedusaDraftOrder';
    cart: {
      __typename?: 'MedusaCart';
      id: string;
      email?: string | null;
      billing_address_id?: string | null;
      shipping_address_id?: string | null;
      region_id: string;
      customer_id?: string | null;
      type: MedusaCartType;
      completed_at?: any | null;
      payment_authorized_at?: any | null;
      created_at?: any | null;
      updated_at?: any | null;
      deleted_at?: any | null;
      metadata?: any | null;
      shipping_total?: number | null;
      discount_total?: number | null;
      tax_total?: number | null;
      total?: number | null;
      subtotal?: number | null;
      gift_card_total?: number | null;
    };
  };
};

export type EmailPreviewQueryVariables = Exact<{
  templateName: Scalars['String'];
}>;

export type EmailPreviewQuery = {
  __typename?: 'Query';
  email_preview: { __typename?: 'MJMLEmailPreview'; html: string };
};

export type SendEmailPreviewMutationVariables = Exact<{
  templateName: Scalars['String'];
  to: Scalars['String'];
}>;

export type SendEmailPreviewMutation = { __typename?: 'Mutation'; send_email_preview: boolean };

export type UserFieldsFragment = {
  __typename?: 'User';
  id: string;
  first_name?: string | null;
  last_name?: string | null;
  is_active: boolean;
  email: string;
  email_verified: boolean;
  phone?: string | null;
  created_at: any;
  updated_at: any;
  postal_code?: string | null;
  stripe_customer_id: string;
  impersonating: boolean;
  medusa_shipping_address_id?: string | null;
  google_oauth_id?: string | null;
  facebook_oauth_id?: string | null;
  shipping_addresses?: Array<{
    __typename?: 'StandardAddress';
    id: string;
    first_name: string;
    last_name: string;
    line1: string;
    line2?: string | null;
    city: string;
    state: string;
    country: string;
    postal_code: string;
    is_default?: boolean | null;
  }> | null;
  meal_preferences?: {
    __typename?: 'MealPreferencesModel';
    allergens?: Array<Allergen> | null;
    diets?: Array<DietType> | null;
  } | null;
  subscription?: {
    __typename?: 'SubscriptionModel';
    id: string;
    user_id: string;
    start_date?: any | null;
    end_date?: any | null;
    frequency: SubscriptionFrequency;
    product_variant_id: string;
    status: SubscriptionStatus;
    status_reason?: string | null;
    product_variant?: {
      __typename?: 'MedusaProductVariant';
      id: string;
      title: string;
      sku: string;
      product_id: string;
      metadata?: any | null;
      options?: Array<{
        __typename?: 'MedusaProductOptionValue';
        id: string;
        value: string;
        option_id: string;
        variant_id: string;
      }> | null;
      variant_preference?: {
        __typename?: 'VariantPreference';
        id: string;
        user_id: string;
        product_variant_id: string;
        favorite?: boolean | null;
        never?: boolean | null;
      } | null;
      dietary_information?: {
        __typename?: 'VariantDietaryInformation';
        allergens: Array<Allergen>;
        diets: Array<DietType>;
        ingredients?: Array<string> | null;
        nutrients: {
          __typename?: 'DietaryNutrients';
          calories: number;
          carbohydrate: number;
          cholesterol: number;
          fat: number;
          fat_saturated: number;
          fat_trans: number;
          fiber: number;
          uncounted_fiber: number;
          sugar: number;
          added_sugar: number;
          sugar_alcohol: number;
          sodium: number;
          calcium: number;
          iron: number;
          vitamin_c: number;
          vitamin_a_IU: number;
          potassium: number;
          fat_monounsaturated: number;
          fat_polyunsaturated: number;
          magnesium: number;
          phosphorus: number;
          zinc: number;
          copper: number;
          manganese: number;
          selenium: number;
          thiamin: number;
          riboflavin: number;
          niacin: number;
          vitamin_b6: number;
          folate: number;
          folic_acid: number;
          chlorine: number;
          vitamin_b12: number;
          vitamin_e: number;
          vitamin_d_IU: number;
          vitamin_k: number;
          protein: number;
        };
      } | null;
      prices?: Array<{
        __typename?: 'MedusaMoneyAmount';
        id: string;
        currency_code: string;
        amount: number;
        sale_amount?: number | null;
      }> | null;
      product?: {
        __typename?: 'MedusaProduct';
        id: string;
        title: string;
        description?: string | null;
        discountable: boolean;
        is_giftcard: boolean;
        handle?: string | null;
        thumbnail?: string | null;
        tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
        variants?: Array<{
          __typename?: 'MedusaProductVariant';
          id: string;
          product_id: string;
          sku: string;
          title: string;
        }> | null;
        collection?: {
          __typename?: 'MedusaProductCollection';
          id: string;
          title?: string | null;
          handle?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type ShippingAddressFieldsFragment = {
  __typename?: 'MedusaAddress';
  first_name: string;
  last_name: string;
  address_1: string;
  address_2?: string | null;
  city: string;
  country_code: string;
  province: string;
  postal_code: string;
};

export type StripePaymentMethodFieldsFragment = {
  __typename?: 'StripePaymentMethod';
  id: string;
  is_default?: boolean | null;
  customer_id?: string | null;
  billing_details: {
    __typename?: 'StripeBillingDetails';
    name?: string | null;
    email?: string | null;
    phone?: string | null;
    address?: {
      __typename?: 'StripeAddress';
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postal_code: string;
      country: string;
    } | null;
  };
  card: {
    __typename?: 'StripePaymentMethodCard';
    brand: string;
    last4: string;
    exp_month: number;
    exp_year: number;
    country: string;
  };
};

export type UserAddressFieldsFragment = {
  __typename?: 'StandardAddress';
  id: string;
  customer_id?: string | null;
  company?: string | null;
  first_name: string;
  last_name: string;
  line1: string;
  line2?: string | null;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  phone?: string | null;
  is_default?: boolean | null;
};

export type DietaryInformationFieldsFragment = {
  __typename?: 'VariantDietaryInformation';
  allergens: Array<Allergen>;
  diets: Array<DietType>;
  ingredients?: Array<string> | null;
  nutrients: {
    __typename?: 'DietaryNutrients';
    calories: number;
    carbohydrate: number;
    cholesterol: number;
    fat: number;
    fat_saturated: number;
    fat_trans: number;
    fiber: number;
    uncounted_fiber: number;
    sugar: number;
    added_sugar: number;
    sugar_alcohol: number;
    sodium: number;
    calcium: number;
    iron: number;
    vitamin_c: number;
    vitamin_a_IU: number;
    potassium: number;
    fat_monounsaturated: number;
    fat_polyunsaturated: number;
    magnesium: number;
    phosphorus: number;
    zinc: number;
    copper: number;
    manganese: number;
    selenium: number;
    thiamin: number;
    riboflavin: number;
    niacin: number;
    vitamin_b6: number;
    folate: number;
    folic_acid: number;
    chlorine: number;
    vitamin_b12: number;
    vitamin_e: number;
    vitamin_d_IU: number;
    vitamin_k: number;
    protein: number;
  };
};

export type ProductVariantFieldsFragment = {
  __typename?: 'MedusaProductVariant';
  id: string;
  title: string;
  sku: string;
  product_id: string;
  metadata?: any | null;
  options?: Array<{
    __typename?: 'MedusaProductOptionValue';
    id: string;
    value: string;
    option_id: string;
    variant_id: string;
  }> | null;
  variant_preference?: {
    __typename?: 'VariantPreference';
    id: string;
    user_id: string;
    product_variant_id: string;
    favorite?: boolean | null;
    never?: boolean | null;
  } | null;
  dietary_information?: {
    __typename?: 'VariantDietaryInformation';
    allergens: Array<Allergen>;
    diets: Array<DietType>;
    ingredients?: Array<string> | null;
    nutrients: {
      __typename?: 'DietaryNutrients';
      calories: number;
      carbohydrate: number;
      cholesterol: number;
      fat: number;
      fat_saturated: number;
      fat_trans: number;
      fiber: number;
      uncounted_fiber: number;
      sugar: number;
      added_sugar: number;
      sugar_alcohol: number;
      sodium: number;
      calcium: number;
      iron: number;
      vitamin_c: number;
      vitamin_a_IU: number;
      potassium: number;
      fat_monounsaturated: number;
      fat_polyunsaturated: number;
      magnesium: number;
      phosphorus: number;
      zinc: number;
      copper: number;
      manganese: number;
      selenium: number;
      thiamin: number;
      riboflavin: number;
      niacin: number;
      vitamin_b6: number;
      folate: number;
      folic_acid: number;
      chlorine: number;
      vitamin_b12: number;
      vitamin_e: number;
      vitamin_d_IU: number;
      vitamin_k: number;
      protein: number;
    };
  } | null;
  prices?: Array<{
    __typename?: 'MedusaMoneyAmount';
    id: string;
    currency_code: string;
    amount: number;
    sale_amount?: number | null;
  }> | null;
  product?: {
    __typename?: 'MedusaProduct';
    id: string;
    title: string;
    description?: string | null;
    discountable: boolean;
    is_giftcard: boolean;
    handle?: string | null;
    thumbnail?: string | null;
    tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
    variants?: Array<{
      __typename?: 'MedusaProductVariant';
      id: string;
      product_id: string;
      sku: string;
      title: string;
    }> | null;
    collection?: {
      __typename?: 'MedusaProductCollection';
      id: string;
      title?: string | null;
      handle?: string | null;
    } | null;
  } | null;
};

export type MedusaDiscountFieldsFragment = {
  __typename?: 'MedusaDiscount';
  id: string;
  code: string;
  is_dynamic: boolean;
  rule_id: string;
  is_disabled: boolean;
  usage_limit?: number | null;
  usage_count: number;
  is_recurring?: boolean | null;
  rule: {
    __typename?: 'MedusaDiscountRule';
    id: string;
    description: string;
    type: MedusaDiscountRuleType;
    value: number;
    allocation: MedusaAllocationType;
  };
};

export type MedusaCartItemFieldsFragment = {
  __typename?: 'MedusaLineItem';
  id: string;
  description?: string | null;
  title?: string | null;
  quantity: number;
  allow_discounts: boolean;
  has_shipping: boolean;
  unit_price: number;
  variant_id: string;
  is_giftcard: boolean;
  thumbnail?: string | null;
  metadata?: any | null;
  created_at?: any | null;
};

export type MedusaCartFieldsFragment = {
  __typename?: 'MedusaCart';
  id: string;
  email?: string | null;
  billing_address_id?: string | null;
  shipping_address_id?: string | null;
  region_id: string;
  customer_id?: string | null;
  type: MedusaCartType;
  completed_at?: any | null;
  payment_authorized_at?: any | null;
  created_at?: any | null;
  updated_at?: any | null;
  deleted_at?: any | null;
  metadata?: any | null;
  shipping_total?: number | null;
  discount_total?: number | null;
  tax_total?: number | null;
  total?: number | null;
  subtotal?: number | null;
  gift_card_total?: number | null;
};

export type GiftCardFieldsFragment = {
  __typename?: 'MedusaGiftCard';
  id: string;
  code: string;
  balance: number;
  value: number;
  is_disabled: boolean;
};

export type OrderFieldsFragment = {
  __typename?: 'SubscriptionOrder';
  id: string;
  complete_order_at?: any | null;
  created_at: any;
  medusa_cart_id?: string | null;
  processed_at?: any | null;
  skip: boolean;
  status: OrderStatus;
  subscription_id: string;
  updated_at: any;
  week?: number | null;
  year?: number | null;
};

export type SubscriptionFieldsFragment = {
  __typename?: 'SubscriptionModel';
  id: string;
  user_id: string;
  start_date?: any | null;
  end_date?: any | null;
  frequency: SubscriptionFrequency;
  product_variant_id: string;
  status: SubscriptionStatus;
  status_reason?: string | null;
  created_at: any;
  updated_at: any;
  product_variant?: {
    __typename?: 'MedusaProductVariant';
    id: string;
    title: string;
    sku: string;
    product_id: string;
    metadata?: any | null;
    options?: Array<{
      __typename?: 'MedusaProductOptionValue';
      id: string;
      value: string;
      option_id: string;
      variant_id: string;
    }> | null;
    variant_preference?: {
      __typename?: 'VariantPreference';
      id: string;
      user_id: string;
      product_variant_id: string;
      favorite?: boolean | null;
      never?: boolean | null;
    } | null;
    dietary_information?: {
      __typename?: 'VariantDietaryInformation';
      allergens: Array<Allergen>;
      diets: Array<DietType>;
      ingredients?: Array<string> | null;
      nutrients: {
        __typename?: 'DietaryNutrients';
        calories: number;
        carbohydrate: number;
        cholesterol: number;
        fat: number;
        fat_saturated: number;
        fat_trans: number;
        fiber: number;
        uncounted_fiber: number;
        sugar: number;
        added_sugar: number;
        sugar_alcohol: number;
        sodium: number;
        calcium: number;
        iron: number;
        vitamin_c: number;
        vitamin_a_IU: number;
        potassium: number;
        fat_monounsaturated: number;
        fat_polyunsaturated: number;
        magnesium: number;
        phosphorus: number;
        zinc: number;
        copper: number;
        manganese: number;
        selenium: number;
        thiamin: number;
        riboflavin: number;
        niacin: number;
        vitamin_b6: number;
        folate: number;
        folic_acid: number;
        chlorine: number;
        vitamin_b12: number;
        vitamin_e: number;
        vitamin_d_IU: number;
        vitamin_k: number;
        protein: number;
      };
    } | null;
    prices?: Array<{
      __typename?: 'MedusaMoneyAmount';
      id: string;
      currency_code: string;
      amount: number;
      sale_amount?: number | null;
    }> | null;
    product?: {
      __typename?: 'MedusaProduct';
      id: string;
      title: string;
      description?: string | null;
      discountable: boolean;
      is_giftcard: boolean;
      handle?: string | null;
      thumbnail?: string | null;
      tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
      variants?: Array<{
        __typename?: 'MedusaProductVariant';
        id: string;
        product_id: string;
        sku: string;
        title: string;
      }> | null;
      collection?: {
        __typename?: 'MedusaProductCollection';
        id: string;
        title?: string | null;
        handle?: string | null;
      } | null;
    } | null;
  } | null;
  current_order?: {
    __typename?: 'SubscriptionOrder';
    id: string;
    complete_order_at?: any | null;
    created_at: any;
    medusa_cart_id?: string | null;
    processed_at?: any | null;
    skip: boolean;
    status: OrderStatus;
    subscription_id: string;
    updated_at: any;
    week?: number | null;
    year?: number | null;
    medusa_cart?: {
      __typename?: 'MedusaCart';
      id: string;
      email?: string | null;
      billing_address_id?: string | null;
      shipping_address_id?: string | null;
      region_id: string;
      customer_id?: string | null;
      type: MedusaCartType;
      completed_at?: any | null;
      payment_authorized_at?: any | null;
      created_at?: any | null;
      updated_at?: any | null;
      deleted_at?: any | null;
      metadata?: any | null;
      shipping_total?: number | null;
      discount_total?: number | null;
      tax_total?: number | null;
      total?: number | null;
      subtotal?: number | null;
      gift_card_total?: number | null;
      items: Array<{
        __typename?: 'MedusaLineItem';
        id: string;
        description?: string | null;
        title?: string | null;
        quantity: number;
        allow_discounts: boolean;
        has_shipping: boolean;
        unit_price: number;
        variant_id: string;
        is_giftcard: boolean;
        thumbnail?: string | null;
        metadata?: any | null;
        created_at?: any | null;
        variant?: {
          __typename?: 'MedusaProductVariant';
          id: string;
          title: string;
          sku: string;
          product_id: string;
          metadata?: any | null;
          options?: Array<{
            __typename?: 'MedusaProductOptionValue';
            id: string;
            value: string;
            option_id: string;
            variant_id: string;
          }> | null;
          variant_preference?: {
            __typename?: 'VariantPreference';
            id: string;
            user_id: string;
            product_variant_id: string;
            favorite?: boolean | null;
            never?: boolean | null;
          } | null;
          dietary_information?: {
            __typename?: 'VariantDietaryInformation';
            allergens: Array<Allergen>;
            diets: Array<DietType>;
            ingredients?: Array<string> | null;
            nutrients: {
              __typename?: 'DietaryNutrients';
              calories: number;
              carbohydrate: number;
              cholesterol: number;
              fat: number;
              fat_saturated: number;
              fat_trans: number;
              fiber: number;
              uncounted_fiber: number;
              sugar: number;
              added_sugar: number;
              sugar_alcohol: number;
              sodium: number;
              calcium: number;
              iron: number;
              vitamin_c: number;
              vitamin_a_IU: number;
              potassium: number;
              fat_monounsaturated: number;
              fat_polyunsaturated: number;
              magnesium: number;
              phosphorus: number;
              zinc: number;
              copper: number;
              manganese: number;
              selenium: number;
              thiamin: number;
              riboflavin: number;
              niacin: number;
              vitamin_b6: number;
              folate: number;
              folic_acid: number;
              chlorine: number;
              vitamin_b12: number;
              vitamin_e: number;
              vitamin_d_IU: number;
              vitamin_k: number;
              protein: number;
            };
          } | null;
          prices?: Array<{
            __typename?: 'MedusaMoneyAmount';
            id: string;
            currency_code: string;
            amount: number;
            sale_amount?: number | null;
          }> | null;
          product?: {
            __typename?: 'MedusaProduct';
            id: string;
            title: string;
            description?: string | null;
            discountable: boolean;
            is_giftcard: boolean;
            handle?: string | null;
            thumbnail?: string | null;
            tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
            variants?: Array<{
              __typename?: 'MedusaProductVariant';
              id: string;
              product_id: string;
              sku: string;
              title: string;
            }> | null;
            collection?: {
              __typename?: 'MedusaProductCollection';
              id: string;
              title?: string | null;
              handle?: string | null;
            } | null;
          } | null;
        } | null;
      }>;
      discounts?: Array<{
        __typename?: 'MedusaDiscount';
        id: string;
        code: string;
        is_dynamic: boolean;
        rule_id: string;
        is_disabled: boolean;
        usage_limit?: number | null;
        usage_count: number;
        is_recurring?: boolean | null;
        rule: {
          __typename?: 'MedusaDiscountRule';
          id: string;
          description: string;
          type: MedusaDiscountRuleType;
          value: number;
          allocation: MedusaAllocationType;
        };
      }> | null;
      gift_cards?: Array<{
        __typename?: 'MedusaGiftCard';
        id: string;
        code: string;
        balance: number;
        value: number;
        is_disabled: boolean;
      }> | null;
    } | null;
  } | null;
  upcoming_orders?: Array<{
    __typename?: 'SubscriptionOrder';
    id: string;
    complete_order_at?: any | null;
    created_at: any;
    medusa_cart_id?: string | null;
    processed_at?: any | null;
    skip: boolean;
    status: OrderStatus;
    subscription_id: string;
    updated_at: any;
    week?: number | null;
    year?: number | null;
  }> | null;
};

export type RegisterMutationVariables = Exact<{
  createUserInput: CreateUserInput;
}>;

export type RegisterMutation = {
  __typename?: 'Mutation';
  register: { __typename?: 'RegisterResponse'; hashed_password: string; JWT: string };
};

export type FinishRegistrationMutationVariables = Exact<{
  validateAccountInput: ValidateAccountInput;
}>;

export type FinishRegistrationMutation = {
  __typename?: 'Mutation';
  finishRegistration: {
    __typename?: 'LoginResponse';
    token: string;
    user: { __typename?: 'User'; id: string; email: string };
  };
};

export type FinishOnboardingMutationVariables = Exact<{
  finishOnboardingInput: FinishOnboardingInput;
}>;

export type FinishOnboardingMutation = {
  __typename?: 'Mutation';
  finishOnboarding: { __typename?: 'SubscriptionModel'; id: string; status: SubscriptionStatus; user_id: string };
};

export type SetPasswordMutationVariables = Exact<{
  setPasswordInput: SetPasswordInput;
}>;

export type SetPasswordMutation = { __typename?: 'Mutation'; setPassword: { __typename?: 'User'; email: string } };

export type UpdatePreferencesMutationVariables = Exact<{
  updatePreferencesInput: MealPreferencesInput;
}>;

export type UpdatePreferencesMutation = {
  __typename?: 'Mutation';
  updatePreferences: {
    __typename?: 'MealPreferencesModel';
    allergens?: Array<Allergen> | null;
    diets?: Array<DietType> | null;
  };
};

export type OrdersQueryVariables = Exact<{ [key: string]: never }>;

export type OrdersQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    subscription?: {
      __typename?: 'SubscriptionModel';
      id: string;
      user_id: string;
      start_date?: any | null;
      end_date?: any | null;
      frequency: SubscriptionFrequency;
      product_variant_id: string;
      status: SubscriptionStatus;
      status_reason?: string | null;
      created_at: any;
      updated_at: any;
      product_variant?: {
        __typename?: 'MedusaProductVariant';
        id: string;
        title: string;
        sku: string;
        product_id: string;
        metadata?: any | null;
        options?: Array<{
          __typename?: 'MedusaProductOptionValue';
          id: string;
          value: string;
          option_id: string;
          variant_id: string;
        }> | null;
        variant_preference?: {
          __typename?: 'VariantPreference';
          id: string;
          user_id: string;
          product_variant_id: string;
          favorite?: boolean | null;
          never?: boolean | null;
        } | null;
        dietary_information?: {
          __typename?: 'VariantDietaryInformation';
          allergens: Array<Allergen>;
          diets: Array<DietType>;
          ingredients?: Array<string> | null;
          nutrients: {
            __typename?: 'DietaryNutrients';
            calories: number;
            carbohydrate: number;
            cholesterol: number;
            fat: number;
            fat_saturated: number;
            fat_trans: number;
            fiber: number;
            uncounted_fiber: number;
            sugar: number;
            added_sugar: number;
            sugar_alcohol: number;
            sodium: number;
            calcium: number;
            iron: number;
            vitamin_c: number;
            vitamin_a_IU: number;
            potassium: number;
            fat_monounsaturated: number;
            fat_polyunsaturated: number;
            magnesium: number;
            phosphorus: number;
            zinc: number;
            copper: number;
            manganese: number;
            selenium: number;
            thiamin: number;
            riboflavin: number;
            niacin: number;
            vitamin_b6: number;
            folate: number;
            folic_acid: number;
            chlorine: number;
            vitamin_b12: number;
            vitamin_e: number;
            vitamin_d_IU: number;
            vitamin_k: number;
            protein: number;
          };
        } | null;
        prices?: Array<{
          __typename?: 'MedusaMoneyAmount';
          id: string;
          currency_code: string;
          amount: number;
          sale_amount?: number | null;
        }> | null;
        product?: {
          __typename?: 'MedusaProduct';
          id: string;
          title: string;
          description?: string | null;
          discountable: boolean;
          is_giftcard: boolean;
          handle?: string | null;
          thumbnail?: string | null;
          tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
          variants?: Array<{
            __typename?: 'MedusaProductVariant';
            id: string;
            product_id: string;
            sku: string;
            title: string;
          }> | null;
          collection?: {
            __typename?: 'MedusaProductCollection';
            id: string;
            title?: string | null;
            handle?: string | null;
          } | null;
        } | null;
      } | null;
      current_order?: {
        __typename?: 'SubscriptionOrder';
        id: string;
        complete_order_at?: any | null;
        created_at: any;
        medusa_cart_id?: string | null;
        processed_at?: any | null;
        skip: boolean;
        status: OrderStatus;
        subscription_id: string;
        updated_at: any;
        week?: number | null;
        year?: number | null;
        medusa_cart?: {
          __typename?: 'MedusaCart';
          id: string;
          email?: string | null;
          billing_address_id?: string | null;
          shipping_address_id?: string | null;
          region_id: string;
          customer_id?: string | null;
          type: MedusaCartType;
          completed_at?: any | null;
          payment_authorized_at?: any | null;
          created_at?: any | null;
          updated_at?: any | null;
          deleted_at?: any | null;
          metadata?: any | null;
          shipping_total?: number | null;
          discount_total?: number | null;
          tax_total?: number | null;
          total?: number | null;
          subtotal?: number | null;
          gift_card_total?: number | null;
          items: Array<{
            __typename?: 'MedusaLineItem';
            id: string;
            description?: string | null;
            title?: string | null;
            quantity: number;
            allow_discounts: boolean;
            has_shipping: boolean;
            unit_price: number;
            variant_id: string;
            is_giftcard: boolean;
            thumbnail?: string | null;
            metadata?: any | null;
            created_at?: any | null;
            variant?: {
              __typename?: 'MedusaProductVariant';
              id: string;
              title: string;
              sku: string;
              product_id: string;
              metadata?: any | null;
              options?: Array<{
                __typename?: 'MedusaProductOptionValue';
                id: string;
                value: string;
                option_id: string;
                variant_id: string;
              }> | null;
              variant_preference?: {
                __typename?: 'VariantPreference';
                id: string;
                user_id: string;
                product_variant_id: string;
                favorite?: boolean | null;
                never?: boolean | null;
              } | null;
              dietary_information?: {
                __typename?: 'VariantDietaryInformation';
                allergens: Array<Allergen>;
                diets: Array<DietType>;
                ingredients?: Array<string> | null;
                nutrients: {
                  __typename?: 'DietaryNutrients';
                  calories: number;
                  carbohydrate: number;
                  cholesterol: number;
                  fat: number;
                  fat_saturated: number;
                  fat_trans: number;
                  fiber: number;
                  uncounted_fiber: number;
                  sugar: number;
                  added_sugar: number;
                  sugar_alcohol: number;
                  sodium: number;
                  calcium: number;
                  iron: number;
                  vitamin_c: number;
                  vitamin_a_IU: number;
                  potassium: number;
                  fat_monounsaturated: number;
                  fat_polyunsaturated: number;
                  magnesium: number;
                  phosphorus: number;
                  zinc: number;
                  copper: number;
                  manganese: number;
                  selenium: number;
                  thiamin: number;
                  riboflavin: number;
                  niacin: number;
                  vitamin_b6: number;
                  folate: number;
                  folic_acid: number;
                  chlorine: number;
                  vitamin_b12: number;
                  vitamin_e: number;
                  vitamin_d_IU: number;
                  vitamin_k: number;
                  protein: number;
                };
              } | null;
              prices?: Array<{
                __typename?: 'MedusaMoneyAmount';
                id: string;
                currency_code: string;
                amount: number;
                sale_amount?: number | null;
              }> | null;
              product?: {
                __typename?: 'MedusaProduct';
                id: string;
                title: string;
                description?: string | null;
                discountable: boolean;
                is_giftcard: boolean;
                handle?: string | null;
                thumbnail?: string | null;
                tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
                variants?: Array<{
                  __typename?: 'MedusaProductVariant';
                  id: string;
                  product_id: string;
                  sku: string;
                  title: string;
                }> | null;
                collection?: {
                  __typename?: 'MedusaProductCollection';
                  id: string;
                  title?: string | null;
                  handle?: string | null;
                } | null;
              } | null;
            } | null;
          }>;
          discounts?: Array<{
            __typename?: 'MedusaDiscount';
            id: string;
            code: string;
            is_dynamic: boolean;
            rule_id: string;
            is_disabled: boolean;
            usage_limit?: number | null;
            usage_count: number;
            is_recurring?: boolean | null;
            rule: {
              __typename?: 'MedusaDiscountRule';
              id: string;
              description: string;
              type: MedusaDiscountRuleType;
              value: number;
              allocation: MedusaAllocationType;
            };
          }> | null;
          gift_cards?: Array<{
            __typename?: 'MedusaGiftCard';
            id: string;
            code: string;
            balance: number;
            value: number;
            is_disabled: boolean;
          }> | null;
        } | null;
      } | null;
      upcoming_orders?: Array<{
        __typename?: 'SubscriptionOrder';
        id: string;
        complete_order_at?: any | null;
        created_at: any;
        medusa_cart_id?: string | null;
        processed_at?: any | null;
        skip: boolean;
        status: OrderStatus;
        subscription_id: string;
        updated_at: any;
        week?: number | null;
        year?: number | null;
      }> | null;
    } | null;
  };
};

export type MyOrdersQueryVariables = Exact<{ [key: string]: never }>;

export type MyOrdersQuery = {
  __typename?: 'Query';
  customerOrders: Array<{
    __typename?: 'MedusaOrder';
    id: string;
    status: MedusaOrderStatus;
    display_id: number;
    first?: boolean | null;
    shipping_total: number;
    discount_total: number;
    tax_total: number;
    total: number;
    subtotal: number;
    paid_total: number;
    customer: { __typename?: 'MedusaCustomer'; id: string };
    payments: Array<{ __typename?: 'MedusaPayment'; data?: any | null }>;
    cart: {
      __typename?: 'MedusaCart';
      id: string;
      email?: string | null;
      billing_address_id?: string | null;
      shipping_address_id?: string | null;
      completed_at?: any | null;
      created_at?: any | null;
      items: Array<{
        __typename?: 'MedusaLineItem';
        id: string;
        description?: string | null;
        title?: string | null;
        quantity: number;
        allow_discounts: boolean;
        has_shipping: boolean;
        unit_price: number;
        variant_id: string;
        is_giftcard: boolean;
        thumbnail?: string | null;
        variant?: {
          __typename?: 'MedusaProductVariant';
          id: string;
          title: string;
          sku: string;
          product_id: string;
          metadata?: any | null;
          options?: Array<{
            __typename?: 'MedusaProductOptionValue';
            id: string;
            value: string;
            option_id: string;
            variant_id: string;
          }> | null;
          variant_preference?: {
            __typename?: 'VariantPreference';
            id: string;
            user_id: string;
            product_variant_id: string;
            favorite?: boolean | null;
            never?: boolean | null;
          } | null;
          dietary_information?: {
            __typename?: 'VariantDietaryInformation';
            allergens: Array<Allergen>;
            diets: Array<DietType>;
            ingredients?: Array<string> | null;
            nutrients: {
              __typename?: 'DietaryNutrients';
              calories: number;
              carbohydrate: number;
              cholesterol: number;
              fat: number;
              fat_saturated: number;
              fat_trans: number;
              fiber: number;
              uncounted_fiber: number;
              sugar: number;
              added_sugar: number;
              sugar_alcohol: number;
              sodium: number;
              calcium: number;
              iron: number;
              vitamin_c: number;
              vitamin_a_IU: number;
              potassium: number;
              fat_monounsaturated: number;
              fat_polyunsaturated: number;
              magnesium: number;
              phosphorus: number;
              zinc: number;
              copper: number;
              manganese: number;
              selenium: number;
              thiamin: number;
              riboflavin: number;
              niacin: number;
              vitamin_b6: number;
              folate: number;
              folic_acid: number;
              chlorine: number;
              vitamin_b12: number;
              vitamin_e: number;
              vitamin_d_IU: number;
              vitamin_k: number;
              protein: number;
            };
          } | null;
          prices?: Array<{
            __typename?: 'MedusaMoneyAmount';
            id: string;
            currency_code: string;
            amount: number;
            sale_amount?: number | null;
          }> | null;
          product?: {
            __typename?: 'MedusaProduct';
            id: string;
            title: string;
            description?: string | null;
            discountable: boolean;
            is_giftcard: boolean;
            handle?: string | null;
            thumbnail?: string | null;
            tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
            variants?: Array<{
              __typename?: 'MedusaProductVariant';
              id: string;
              product_id: string;
              sku: string;
              title: string;
            }> | null;
            collection?: {
              __typename?: 'MedusaProductCollection';
              id: string;
              title?: string | null;
              handle?: string | null;
            } | null;
          } | null;
        } | null;
        product_rating?: {
          __typename?: 'RatingModel';
          id: string;
          user_id: string;
          medusa_line_item_id: string;
          medusa_order_id: string;
          product_variant_id: string;
          rating?: number | null;
          note?: string | null;
        } | null;
      }>;
    };
  }>;
};

export type SaveProductRatingMutationVariables = Exact<{
  saveProductRatingInput: SaveProductRatingInput;
}>;

export type SaveProductRatingMutation = {
  __typename?: 'Mutation';
  saveProductRating: {
    __typename?: 'RatingModel';
    id: string;
    user_id: string;
    medusa_order_id: string;
    medusa_line_item_id: string;
    product_variant_id: string;
    rating?: number | null;
    note?: string | null;
    created_at?: any | null;
  };
};

export type UpdateOrderMutationVariables = Exact<{
  updateSubscriptionOrderInput: UpdateSubscriptionOrderInput;
}>;

export type UpdateOrderMutation = {
  __typename?: 'Mutation';
  updateSubscriptionOrder: {
    __typename?: 'SubscriptionOrder';
    id: string;
    complete_order_at?: any | null;
    created_at: any;
    medusa_cart_id?: string | null;
    processed_at?: any | null;
    skip: boolean;
    status: OrderStatus;
    subscription_id: string;
    updated_at: any;
    week?: number | null;
    year?: number | null;
  };
};

export type CheckPostalCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;

export type CheckPostalCodeMutation = { __typename?: 'Mutation'; postalCodeAllowed: boolean };

export type ProductVariantQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type ProductVariantQuery = {
  __typename?: 'Query';
  productVariant: {
    __typename?: 'MedusaProductVariant';
    id: string;
    title: string;
    sku: string;
    product_id: string;
    metadata?: any | null;
    options?: Array<{
      __typename?: 'MedusaProductOptionValue';
      id: string;
      value: string;
      option_id: string;
      variant_id: string;
    }> | null;
    variant_preference?: {
      __typename?: 'VariantPreference';
      id: string;
      user_id: string;
      product_variant_id: string;
      favorite?: boolean | null;
      never?: boolean | null;
    } | null;
    dietary_information?: {
      __typename?: 'VariantDietaryInformation';
      allergens: Array<Allergen>;
      diets: Array<DietType>;
      ingredients?: Array<string> | null;
      nutrients: {
        __typename?: 'DietaryNutrients';
        calories: number;
        carbohydrate: number;
        cholesterol: number;
        fat: number;
        fat_saturated: number;
        fat_trans: number;
        fiber: number;
        uncounted_fiber: number;
        sugar: number;
        added_sugar: number;
        sugar_alcohol: number;
        sodium: number;
        calcium: number;
        iron: number;
        vitamin_c: number;
        vitamin_a_IU: number;
        potassium: number;
        fat_monounsaturated: number;
        fat_polyunsaturated: number;
        magnesium: number;
        phosphorus: number;
        zinc: number;
        copper: number;
        manganese: number;
        selenium: number;
        thiamin: number;
        riboflavin: number;
        niacin: number;
        vitamin_b6: number;
        folate: number;
        folic_acid: number;
        chlorine: number;
        vitamin_b12: number;
        vitamin_e: number;
        vitamin_d_IU: number;
        vitamin_k: number;
        protein: number;
      };
    } | null;
    prices?: Array<{
      __typename?: 'MedusaMoneyAmount';
      id: string;
      currency_code: string;
      amount: number;
      sale_amount?: number | null;
    }> | null;
    product?: {
      __typename?: 'MedusaProduct';
      id: string;
      title: string;
      description?: string | null;
      discountable: boolean;
      is_giftcard: boolean;
      handle?: string | null;
      thumbnail?: string | null;
      tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
      variants?: Array<{
        __typename?: 'MedusaProductVariant';
        id: string;
        product_id: string;
        sku: string;
        title: string;
      }> | null;
      collection?: {
        __typename?: 'MedusaProductCollection';
        id: string;
        title?: string | null;
        handle?: string | null;
      } | null;
    } | null;
  };
};

export type ProductsQueryVariables = Exact<{
  collection_title?: InputMaybe<Scalars['String']>;
  sku_filter?: InputMaybe<Scalars['String']>;
}>;

export type ProductsQuery = {
  __typename?: 'Query';
  productVariants: Array<{
    __typename?: 'MedusaProductVariant';
    id: string;
    title: string;
    sku: string;
    product_id: string;
    metadata?: any | null;
    options?: Array<{
      __typename?: 'MedusaProductOptionValue';
      id: string;
      value: string;
      option_id: string;
      variant_id: string;
    }> | null;
    variant_preference?: {
      __typename?: 'VariantPreference';
      id: string;
      user_id: string;
      product_variant_id: string;
      favorite?: boolean | null;
      never?: boolean | null;
    } | null;
    dietary_information?: {
      __typename?: 'VariantDietaryInformation';
      allergens: Array<Allergen>;
      diets: Array<DietType>;
      ingredients?: Array<string> | null;
      nutrients: {
        __typename?: 'DietaryNutrients';
        calories: number;
        carbohydrate: number;
        cholesterol: number;
        fat: number;
        fat_saturated: number;
        fat_trans: number;
        fiber: number;
        uncounted_fiber: number;
        sugar: number;
        added_sugar: number;
        sugar_alcohol: number;
        sodium: number;
        calcium: number;
        iron: number;
        vitamin_c: number;
        vitamin_a_IU: number;
        potassium: number;
        fat_monounsaturated: number;
        fat_polyunsaturated: number;
        magnesium: number;
        phosphorus: number;
        zinc: number;
        copper: number;
        manganese: number;
        selenium: number;
        thiamin: number;
        riboflavin: number;
        niacin: number;
        vitamin_b6: number;
        folate: number;
        folic_acid: number;
        chlorine: number;
        vitamin_b12: number;
        vitamin_e: number;
        vitamin_d_IU: number;
        vitamin_k: number;
        protein: number;
      };
    } | null;
    prices?: Array<{
      __typename?: 'MedusaMoneyAmount';
      id: string;
      currency_code: string;
      amount: number;
      sale_amount?: number | null;
    }> | null;
    product?: {
      __typename?: 'MedusaProduct';
      id: string;
      title: string;
      description?: string | null;
      discountable: boolean;
      is_giftcard: boolean;
      handle?: string | null;
      thumbnail?: string | null;
      tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
      variants?: Array<{
        __typename?: 'MedusaProductVariant';
        id: string;
        product_id: string;
        sku: string;
        title: string;
      }> | null;
      collection?: {
        __typename?: 'MedusaProductCollection';
        id: string;
        title?: string | null;
        handle?: string | null;
      } | null;
    } | null;
  }>;
};

export type SubscriptionProductsQueryVariables = Exact<{ [key: string]: never }>;

export type SubscriptionProductsQuery = {
  __typename?: 'Query';
  standardSubscriptions: Array<{
    __typename?: 'MedusaProductVariant';
    id: string;
    title: string;
    sku: string;
    product_id: string;
    metadata?: any | null;
    options?: Array<{
      __typename?: 'MedusaProductOptionValue';
      id: string;
      value: string;
      option_id: string;
      variant_id: string;
    }> | null;
    variant_preference?: {
      __typename?: 'VariantPreference';
      id: string;
      user_id: string;
      product_variant_id: string;
      favorite?: boolean | null;
      never?: boolean | null;
    } | null;
    dietary_information?: {
      __typename?: 'VariantDietaryInformation';
      allergens: Array<Allergen>;
      diets: Array<DietType>;
      ingredients?: Array<string> | null;
      nutrients: {
        __typename?: 'DietaryNutrients';
        calories: number;
        carbohydrate: number;
        cholesterol: number;
        fat: number;
        fat_saturated: number;
        fat_trans: number;
        fiber: number;
        uncounted_fiber: number;
        sugar: number;
        added_sugar: number;
        sugar_alcohol: number;
        sodium: number;
        calcium: number;
        iron: number;
        vitamin_c: number;
        vitamin_a_IU: number;
        potassium: number;
        fat_monounsaturated: number;
        fat_polyunsaturated: number;
        magnesium: number;
        phosphorus: number;
        zinc: number;
        copper: number;
        manganese: number;
        selenium: number;
        thiamin: number;
        riboflavin: number;
        niacin: number;
        vitamin_b6: number;
        folate: number;
        folic_acid: number;
        chlorine: number;
        vitamin_b12: number;
        vitamin_e: number;
        vitamin_d_IU: number;
        vitamin_k: number;
        protein: number;
      };
    } | null;
    prices?: Array<{
      __typename?: 'MedusaMoneyAmount';
      id: string;
      currency_code: string;
      amount: number;
      sale_amount?: number | null;
    }> | null;
    product?: {
      __typename?: 'MedusaProduct';
      id: string;
      title: string;
      description?: string | null;
      discountable: boolean;
      is_giftcard: boolean;
      handle?: string | null;
      thumbnail?: string | null;
      tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
      variants?: Array<{
        __typename?: 'MedusaProductVariant';
        id: string;
        product_id: string;
        sku: string;
        title: string;
      }> | null;
      collection?: {
        __typename?: 'MedusaProductCollection';
        id: string;
        title?: string | null;
        handle?: string | null;
      } | null;
    } | null;
  }>;
};

export type OrderedMealProductsQueryVariables = Exact<{
  currentSubscriptionOrderId?: InputMaybe<Scalars['String']>;
  filterPremiums?: InputMaybe<Scalars['Boolean']>;
}>;

export type OrderedMealProductsQuery = {
  __typename?: 'Query';
  standardMeals: Array<{
    __typename?: 'MedusaProductVariant';
    id: string;
    title: string;
    sku: string;
    product_id: string;
    metadata?: any | null;
    options?: Array<{
      __typename?: 'MedusaProductOptionValue';
      id: string;
      value: string;
      option_id: string;
      variant_id: string;
    }> | null;
    variant_preference?: {
      __typename?: 'VariantPreference';
      id: string;
      user_id: string;
      product_variant_id: string;
      favorite?: boolean | null;
      never?: boolean | null;
    } | null;
    dietary_information?: {
      __typename?: 'VariantDietaryInformation';
      allergens: Array<Allergen>;
      diets: Array<DietType>;
      ingredients?: Array<string> | null;
      nutrients: {
        __typename?: 'DietaryNutrients';
        calories: number;
        carbohydrate: number;
        cholesterol: number;
        fat: number;
        fat_saturated: number;
        fat_trans: number;
        fiber: number;
        uncounted_fiber: number;
        sugar: number;
        added_sugar: number;
        sugar_alcohol: number;
        sodium: number;
        calcium: number;
        iron: number;
        vitamin_c: number;
        vitamin_a_IU: number;
        potassium: number;
        fat_monounsaturated: number;
        fat_polyunsaturated: number;
        magnesium: number;
        phosphorus: number;
        zinc: number;
        copper: number;
        manganese: number;
        selenium: number;
        thiamin: number;
        riboflavin: number;
        niacin: number;
        vitamin_b6: number;
        folate: number;
        folic_acid: number;
        chlorine: number;
        vitamin_b12: number;
        vitamin_e: number;
        vitamin_d_IU: number;
        vitamin_k: number;
        protein: number;
      };
    } | null;
    prices?: Array<{
      __typename?: 'MedusaMoneyAmount';
      id: string;
      currency_code: string;
      amount: number;
      sale_amount?: number | null;
    }> | null;
    product?: {
      __typename?: 'MedusaProduct';
      id: string;
      title: string;
      description?: string | null;
      discountable: boolean;
      is_giftcard: boolean;
      handle?: string | null;
      thumbnail?: string | null;
      tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
      variants?: Array<{
        __typename?: 'MedusaProductVariant';
        id: string;
        product_id: string;
        sku: string;
        title: string;
      }> | null;
      collection?: {
        __typename?: 'MedusaProductCollection';
        id: string;
        title?: string | null;
        handle?: string | null;
      } | null;
    } | null;
  }>;
};

export type MealProductsQueryVariables = Exact<{ [key: string]: never }>;

export type MealProductsQuery = {
  __typename?: 'Query';
  standardMeals: Array<{
    __typename?: 'MedusaProductVariant';
    id: string;
    title: string;
    sku: string;
    product_id: string;
    metadata?: any | null;
    options?: Array<{
      __typename?: 'MedusaProductOptionValue';
      id: string;
      value: string;
      option_id: string;
      variant_id: string;
    }> | null;
    variant_preference?: {
      __typename?: 'VariantPreference';
      id: string;
      user_id: string;
      product_variant_id: string;
      favorite?: boolean | null;
      never?: boolean | null;
    } | null;
    dietary_information?: {
      __typename?: 'VariantDietaryInformation';
      allergens: Array<Allergen>;
      diets: Array<DietType>;
      ingredients?: Array<string> | null;
      nutrients: {
        __typename?: 'DietaryNutrients';
        calories: number;
        carbohydrate: number;
        cholesterol: number;
        fat: number;
        fat_saturated: number;
        fat_trans: number;
        fiber: number;
        uncounted_fiber: number;
        sugar: number;
        added_sugar: number;
        sugar_alcohol: number;
        sodium: number;
        calcium: number;
        iron: number;
        vitamin_c: number;
        vitamin_a_IU: number;
        potassium: number;
        fat_monounsaturated: number;
        fat_polyunsaturated: number;
        magnesium: number;
        phosphorus: number;
        zinc: number;
        copper: number;
        manganese: number;
        selenium: number;
        thiamin: number;
        riboflavin: number;
        niacin: number;
        vitamin_b6: number;
        folate: number;
        folic_acid: number;
        chlorine: number;
        vitamin_b12: number;
        vitamin_e: number;
        vitamin_d_IU: number;
        vitamin_k: number;
        protein: number;
      };
    } | null;
    prices?: Array<{
      __typename?: 'MedusaMoneyAmount';
      id: string;
      currency_code: string;
      amount: number;
      sale_amount?: number | null;
    }> | null;
    product?: {
      __typename?: 'MedusaProduct';
      id: string;
      title: string;
      description?: string | null;
      discountable: boolean;
      is_giftcard: boolean;
      handle?: string | null;
      thumbnail?: string | null;
      tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
      variants?: Array<{
        __typename?: 'MedusaProductVariant';
        id: string;
        product_id: string;
        sku: string;
        title: string;
      }> | null;
      collection?: {
        __typename?: 'MedusaProductCollection';
        id: string;
        title?: string | null;
        handle?: string | null;
      } | null;
    } | null;
  }>;
};

export type ExtraProductsQueryVariables = Exact<{ [key: string]: never }>;

export type ExtraProductsQuery = {
  __typename?: 'Query';
  standardExtras: Array<{
    __typename?: 'MedusaProductVariant';
    id: string;
    title: string;
    sku: string;
    product_id: string;
    metadata?: any | null;
    options?: Array<{
      __typename?: 'MedusaProductOptionValue';
      id: string;
      value: string;
      option_id: string;
      variant_id: string;
    }> | null;
    variant_preference?: {
      __typename?: 'VariantPreference';
      id: string;
      user_id: string;
      product_variant_id: string;
      favorite?: boolean | null;
      never?: boolean | null;
    } | null;
    dietary_information?: {
      __typename?: 'VariantDietaryInformation';
      allergens: Array<Allergen>;
      diets: Array<DietType>;
      ingredients?: Array<string> | null;
      nutrients: {
        __typename?: 'DietaryNutrients';
        calories: number;
        carbohydrate: number;
        cholesterol: number;
        fat: number;
        fat_saturated: number;
        fat_trans: number;
        fiber: number;
        uncounted_fiber: number;
        sugar: number;
        added_sugar: number;
        sugar_alcohol: number;
        sodium: number;
        calcium: number;
        iron: number;
        vitamin_c: number;
        vitamin_a_IU: number;
        potassium: number;
        fat_monounsaturated: number;
        fat_polyunsaturated: number;
        magnesium: number;
        phosphorus: number;
        zinc: number;
        copper: number;
        manganese: number;
        selenium: number;
        thiamin: number;
        riboflavin: number;
        niacin: number;
        vitamin_b6: number;
        folate: number;
        folic_acid: number;
        chlorine: number;
        vitamin_b12: number;
        vitamin_e: number;
        vitamin_d_IU: number;
        vitamin_k: number;
        protein: number;
      };
    } | null;
    prices?: Array<{
      __typename?: 'MedusaMoneyAmount';
      id: string;
      currency_code: string;
      amount: number;
      sale_amount?: number | null;
    }> | null;
    product?: {
      __typename?: 'MedusaProduct';
      id: string;
      title: string;
      description?: string | null;
      discountable: boolean;
      is_giftcard: boolean;
      handle?: string | null;
      thumbnail?: string | null;
      tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
      variants?: Array<{
        __typename?: 'MedusaProductVariant';
        id: string;
        product_id: string;
        sku: string;
        title: string;
      }> | null;
      collection?: {
        __typename?: 'MedusaProductCollection';
        id: string;
        title?: string | null;
        handle?: string | null;
      } | null;
    } | null;
  }>;
};

export type OnboardingMealSelectionQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingMealSelectionQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    subscription?: {
      __typename?: 'SubscriptionModel';
      product_variant_id: string;
      current_order?: {
        __typename?: 'SubscriptionOrder';
        medusa_cart?: {
          __typename?: 'MedusaCart';
          items: Array<{
            __typename?: 'MedusaLineItem';
            id: string;
            allow_discounts: boolean;
            has_shipping: boolean;
            is_giftcard: boolean;
            quantity: number;
            unit_price: number;
            variant_id: string;
            title?: string | null;
            metadata?: any | null;
            variant?: {
              __typename?: 'MedusaProductVariant';
              id: string;
              title: string;
              sku: string;
              product_id: string;
              metadata?: any | null;
              options?: Array<{
                __typename?: 'MedusaProductOptionValue';
                id: string;
                value: string;
                option_id: string;
                variant_id: string;
              }> | null;
              variant_preference?: {
                __typename?: 'VariantPreference';
                id: string;
                user_id: string;
                product_variant_id: string;
                favorite?: boolean | null;
                never?: boolean | null;
              } | null;
              dietary_information?: {
                __typename?: 'VariantDietaryInformation';
                allergens: Array<Allergen>;
                diets: Array<DietType>;
                ingredients?: Array<string> | null;
                nutrients: {
                  __typename?: 'DietaryNutrients';
                  calories: number;
                  carbohydrate: number;
                  cholesterol: number;
                  fat: number;
                  fat_saturated: number;
                  fat_trans: number;
                  fiber: number;
                  uncounted_fiber: number;
                  sugar: number;
                  added_sugar: number;
                  sugar_alcohol: number;
                  sodium: number;
                  calcium: number;
                  iron: number;
                  vitamin_c: number;
                  vitamin_a_IU: number;
                  potassium: number;
                  fat_monounsaturated: number;
                  fat_polyunsaturated: number;
                  magnesium: number;
                  phosphorus: number;
                  zinc: number;
                  copper: number;
                  manganese: number;
                  selenium: number;
                  thiamin: number;
                  riboflavin: number;
                  niacin: number;
                  vitamin_b6: number;
                  folate: number;
                  folic_acid: number;
                  chlorine: number;
                  vitamin_b12: number;
                  vitamin_e: number;
                  vitamin_d_IU: number;
                  vitamin_k: number;
                  protein: number;
                };
              } | null;
              prices?: Array<{
                __typename?: 'MedusaMoneyAmount';
                id: string;
                currency_code: string;
                amount: number;
                sale_amount?: number | null;
              }> | null;
              product?: {
                __typename?: 'MedusaProduct';
                id: string;
                title: string;
                description?: string | null;
                discountable: boolean;
                is_giftcard: boolean;
                handle?: string | null;
                thumbnail?: string | null;
                tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
                variants?: Array<{
                  __typename?: 'MedusaProductVariant';
                  id: string;
                  product_id: string;
                  sku: string;
                  title: string;
                }> | null;
                collection?: {
                  __typename?: 'MedusaProductCollection';
                  id: string;
                  title?: string | null;
                  handle?: string | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
      } | null;
      subscription_items?: Array<{
        __typename?: 'SubscriptionItemModel';
        id: string;
        subscription_id: string;
        product_variant_id: string;
        quantity: number;
        created_at: any;
        updated_at: any;
        product_variant?: {
          __typename?: 'MedusaProductVariant';
          id: string;
          title: string;
          sku: string;
          product_id: string;
          metadata?: any | null;
          options?: Array<{
            __typename?: 'MedusaProductOptionValue';
            id: string;
            value: string;
            option_id: string;
            variant_id: string;
          }> | null;
          variant_preference?: {
            __typename?: 'VariantPreference';
            id: string;
            user_id: string;
            product_variant_id: string;
            favorite?: boolean | null;
            never?: boolean | null;
          } | null;
          dietary_information?: {
            __typename?: 'VariantDietaryInformation';
            allergens: Array<Allergen>;
            diets: Array<DietType>;
            ingredients?: Array<string> | null;
            nutrients: {
              __typename?: 'DietaryNutrients';
              calories: number;
              carbohydrate: number;
              cholesterol: number;
              fat: number;
              fat_saturated: number;
              fat_trans: number;
              fiber: number;
              uncounted_fiber: number;
              sugar: number;
              added_sugar: number;
              sugar_alcohol: number;
              sodium: number;
              calcium: number;
              iron: number;
              vitamin_c: number;
              vitamin_a_IU: number;
              potassium: number;
              fat_monounsaturated: number;
              fat_polyunsaturated: number;
              magnesium: number;
              phosphorus: number;
              zinc: number;
              copper: number;
              manganese: number;
              selenium: number;
              thiamin: number;
              riboflavin: number;
              niacin: number;
              vitamin_b6: number;
              folate: number;
              folic_acid: number;
              chlorine: number;
              vitamin_b12: number;
              vitamin_e: number;
              vitamin_d_IU: number;
              vitamin_k: number;
              protein: number;
            };
          } | null;
          prices?: Array<{
            __typename?: 'MedusaMoneyAmount';
            id: string;
            currency_code: string;
            amount: number;
            sale_amount?: number | null;
          }> | null;
          product?: {
            __typename?: 'MedusaProduct';
            id: string;
            title: string;
            description?: string | null;
            discountable: boolean;
            is_giftcard: boolean;
            handle?: string | null;
            thumbnail?: string | null;
            tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
            variants?: Array<{
              __typename?: 'MedusaProductVariant';
              id: string;
              product_id: string;
              sku: string;
              title: string;
            }> | null;
            collection?: {
              __typename?: 'MedusaProductCollection';
              id: string;
              title?: string | null;
              handle?: string | null;
            } | null;
          } | null;
        } | null;
      }> | null;
    } | null;
  };
};

export type CreateStripeSetupIntentMutationVariables = Exact<{ [key: string]: never }>;

export type CreateStripeSetupIntentMutation = {
  __typename?: 'Mutation';
  createStripeSetupIntent: { __typename?: 'StripeSetupIntent'; client_secret: string };
};

export type UpsertExtraLineItemMutationVariables = Exact<{
  input: UpsertExtraLineItemInput;
}>;

export type UpsertExtraLineItemMutation = {
  __typename?: 'Mutation';
  upsertExtraLineItem: {
    __typename?: 'SubscriptionOrder';
    medusa_cart?: {
      __typename?: 'MedusaCart';
      id: string;
      email?: string | null;
      billing_address_id?: string | null;
      shipping_address_id?: string | null;
      region_id: string;
      customer_id?: string | null;
      type: MedusaCartType;
      completed_at?: any | null;
      payment_authorized_at?: any | null;
      created_at?: any | null;
      updated_at?: any | null;
      deleted_at?: any | null;
      metadata?: any | null;
      shipping_total?: number | null;
      discount_total?: number | null;
      tax_total?: number | null;
      total?: number | null;
      subtotal?: number | null;
      gift_card_total?: number | null;
      items: Array<{
        __typename?: 'MedusaLineItem';
        id: string;
        description?: string | null;
        title?: string | null;
        quantity: number;
        allow_discounts: boolean;
        has_shipping: boolean;
        unit_price: number;
        variant_id: string;
        is_giftcard: boolean;
        thumbnail?: string | null;
        metadata?: any | null;
        created_at?: any | null;
        variant?: {
          __typename?: 'MedusaProductVariant';
          id: string;
          title: string;
          sku: string;
          product_id: string;
          metadata?: any | null;
          options?: Array<{
            __typename?: 'MedusaProductOptionValue';
            id: string;
            value: string;
            option_id: string;
            variant_id: string;
          }> | null;
          variant_preference?: {
            __typename?: 'VariantPreference';
            id: string;
            user_id: string;
            product_variant_id: string;
            favorite?: boolean | null;
            never?: boolean | null;
          } | null;
          dietary_information?: {
            __typename?: 'VariantDietaryInformation';
            allergens: Array<Allergen>;
            diets: Array<DietType>;
            ingredients?: Array<string> | null;
            nutrients: {
              __typename?: 'DietaryNutrients';
              calories: number;
              carbohydrate: number;
              cholesterol: number;
              fat: number;
              fat_saturated: number;
              fat_trans: number;
              fiber: number;
              uncounted_fiber: number;
              sugar: number;
              added_sugar: number;
              sugar_alcohol: number;
              sodium: number;
              calcium: number;
              iron: number;
              vitamin_c: number;
              vitamin_a_IU: number;
              potassium: number;
              fat_monounsaturated: number;
              fat_polyunsaturated: number;
              magnesium: number;
              phosphorus: number;
              zinc: number;
              copper: number;
              manganese: number;
              selenium: number;
              thiamin: number;
              riboflavin: number;
              niacin: number;
              vitamin_b6: number;
              folate: number;
              folic_acid: number;
              chlorine: number;
              vitamin_b12: number;
              vitamin_e: number;
              vitamin_d_IU: number;
              vitamin_k: number;
              protein: number;
            };
          } | null;
          prices?: Array<{
            __typename?: 'MedusaMoneyAmount';
            id: string;
            currency_code: string;
            amount: number;
            sale_amount?: number | null;
          }> | null;
          product?: {
            __typename?: 'MedusaProduct';
            id: string;
            title: string;
            description?: string | null;
            discountable: boolean;
            is_giftcard: boolean;
            handle?: string | null;
            thumbnail?: string | null;
            tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
            variants?: Array<{
              __typename?: 'MedusaProductVariant';
              id: string;
              product_id: string;
              sku: string;
              title: string;
            }> | null;
            collection?: {
              __typename?: 'MedusaProductCollection';
              id: string;
              title?: string | null;
              handle?: string | null;
            } | null;
          } | null;
        } | null;
      }>;
    } | null;
  };
};

export type CreateSubscriptionMutationVariables = Exact<{
  createUserSubscriptionInput: CreateUserSubscriptionInput;
}>;

export type CreateSubscriptionMutation = {
  __typename?: 'Mutation';
  createSubscription: { __typename?: 'SubscriptionModel'; product_variant_id: string };
};

export type UpdateSubscriptionMutationVariables = Exact<{
  updateUserSubscriptionInput: CreateUserSubscriptionInput;
}>;

export type UpdateSubscriptionMutation = {
  __typename?: 'Mutation';
  updateSubscription: {
    __typename?: 'SubscriptionModel';
    id: string;
    user_id: string;
    start_date?: any | null;
    end_date?: any | null;
    frequency: SubscriptionFrequency;
    product_variant_id: string;
    status: SubscriptionStatus;
    status_reason?: string | null;
    created_at: any;
    updated_at: any;
    product_variant?: {
      __typename?: 'MedusaProductVariant';
      id: string;
      title: string;
      sku: string;
      product_id: string;
      metadata?: any | null;
      options?: Array<{
        __typename?: 'MedusaProductOptionValue';
        id: string;
        value: string;
        option_id: string;
        variant_id: string;
      }> | null;
      variant_preference?: {
        __typename?: 'VariantPreference';
        id: string;
        user_id: string;
        product_variant_id: string;
        favorite?: boolean | null;
        never?: boolean | null;
      } | null;
      dietary_information?: {
        __typename?: 'VariantDietaryInformation';
        allergens: Array<Allergen>;
        diets: Array<DietType>;
        ingredients?: Array<string> | null;
        nutrients: {
          __typename?: 'DietaryNutrients';
          calories: number;
          carbohydrate: number;
          cholesterol: number;
          fat: number;
          fat_saturated: number;
          fat_trans: number;
          fiber: number;
          uncounted_fiber: number;
          sugar: number;
          added_sugar: number;
          sugar_alcohol: number;
          sodium: number;
          calcium: number;
          iron: number;
          vitamin_c: number;
          vitamin_a_IU: number;
          potassium: number;
          fat_monounsaturated: number;
          fat_polyunsaturated: number;
          magnesium: number;
          phosphorus: number;
          zinc: number;
          copper: number;
          manganese: number;
          selenium: number;
          thiamin: number;
          riboflavin: number;
          niacin: number;
          vitamin_b6: number;
          folate: number;
          folic_acid: number;
          chlorine: number;
          vitamin_b12: number;
          vitamin_e: number;
          vitamin_d_IU: number;
          vitamin_k: number;
          protein: number;
        };
      } | null;
      prices?: Array<{
        __typename?: 'MedusaMoneyAmount';
        id: string;
        currency_code: string;
        amount: number;
        sale_amount?: number | null;
      }> | null;
      product?: {
        __typename?: 'MedusaProduct';
        id: string;
        title: string;
        description?: string | null;
        discountable: boolean;
        is_giftcard: boolean;
        handle?: string | null;
        thumbnail?: string | null;
        tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
        variants?: Array<{
          __typename?: 'MedusaProductVariant';
          id: string;
          product_id: string;
          sku: string;
          title: string;
        }> | null;
        collection?: {
          __typename?: 'MedusaProductCollection';
          id: string;
          title?: string | null;
          handle?: string | null;
        } | null;
      } | null;
    } | null;
    current_order?: {
      __typename?: 'SubscriptionOrder';
      id: string;
      complete_order_at?: any | null;
      created_at: any;
      medusa_cart_id?: string | null;
      processed_at?: any | null;
      skip: boolean;
      status: OrderStatus;
      subscription_id: string;
      updated_at: any;
      week?: number | null;
      year?: number | null;
      medusa_cart?: {
        __typename?: 'MedusaCart';
        id: string;
        email?: string | null;
        billing_address_id?: string | null;
        shipping_address_id?: string | null;
        region_id: string;
        customer_id?: string | null;
        type: MedusaCartType;
        completed_at?: any | null;
        payment_authorized_at?: any | null;
        created_at?: any | null;
        updated_at?: any | null;
        deleted_at?: any | null;
        metadata?: any | null;
        shipping_total?: number | null;
        discount_total?: number | null;
        tax_total?: number | null;
        total?: number | null;
        subtotal?: number | null;
        gift_card_total?: number | null;
        items: Array<{
          __typename?: 'MedusaLineItem';
          id: string;
          description?: string | null;
          title?: string | null;
          quantity: number;
          allow_discounts: boolean;
          has_shipping: boolean;
          unit_price: number;
          variant_id: string;
          is_giftcard: boolean;
          thumbnail?: string | null;
          metadata?: any | null;
          created_at?: any | null;
          variant?: {
            __typename?: 'MedusaProductVariant';
            id: string;
            title: string;
            sku: string;
            product_id: string;
            metadata?: any | null;
            options?: Array<{
              __typename?: 'MedusaProductOptionValue';
              id: string;
              value: string;
              option_id: string;
              variant_id: string;
            }> | null;
            variant_preference?: {
              __typename?: 'VariantPreference';
              id: string;
              user_id: string;
              product_variant_id: string;
              favorite?: boolean | null;
              never?: boolean | null;
            } | null;
            dietary_information?: {
              __typename?: 'VariantDietaryInformation';
              allergens: Array<Allergen>;
              diets: Array<DietType>;
              ingredients?: Array<string> | null;
              nutrients: {
                __typename?: 'DietaryNutrients';
                calories: number;
                carbohydrate: number;
                cholesterol: number;
                fat: number;
                fat_saturated: number;
                fat_trans: number;
                fiber: number;
                uncounted_fiber: number;
                sugar: number;
                added_sugar: number;
                sugar_alcohol: number;
                sodium: number;
                calcium: number;
                iron: number;
                vitamin_c: number;
                vitamin_a_IU: number;
                potassium: number;
                fat_monounsaturated: number;
                fat_polyunsaturated: number;
                magnesium: number;
                phosphorus: number;
                zinc: number;
                copper: number;
                manganese: number;
                selenium: number;
                thiamin: number;
                riboflavin: number;
                niacin: number;
                vitamin_b6: number;
                folate: number;
                folic_acid: number;
                chlorine: number;
                vitamin_b12: number;
                vitamin_e: number;
                vitamin_d_IU: number;
                vitamin_k: number;
                protein: number;
              };
            } | null;
            prices?: Array<{
              __typename?: 'MedusaMoneyAmount';
              id: string;
              currency_code: string;
              amount: number;
              sale_amount?: number | null;
            }> | null;
            product?: {
              __typename?: 'MedusaProduct';
              id: string;
              title: string;
              description?: string | null;
              discountable: boolean;
              is_giftcard: boolean;
              handle?: string | null;
              thumbnail?: string | null;
              tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
              variants?: Array<{
                __typename?: 'MedusaProductVariant';
                id: string;
                product_id: string;
                sku: string;
                title: string;
              }> | null;
              collection?: {
                __typename?: 'MedusaProductCollection';
                id: string;
                title?: string | null;
                handle?: string | null;
              } | null;
            } | null;
          } | null;
        }>;
        discounts?: Array<{
          __typename?: 'MedusaDiscount';
          id: string;
          code: string;
          is_dynamic: boolean;
          rule_id: string;
          is_disabled: boolean;
          usage_limit?: number | null;
          usage_count: number;
          is_recurring?: boolean | null;
          rule: {
            __typename?: 'MedusaDiscountRule';
            id: string;
            description: string;
            type: MedusaDiscountRuleType;
            value: number;
            allocation: MedusaAllocationType;
          };
        }> | null;
        gift_cards?: Array<{
          __typename?: 'MedusaGiftCard';
          id: string;
          code: string;
          balance: number;
          value: number;
          is_disabled: boolean;
        }> | null;
      } | null;
    } | null;
    upcoming_orders?: Array<{
      __typename?: 'SubscriptionOrder';
      id: string;
      complete_order_at?: any | null;
      created_at: any;
      medusa_cart_id?: string | null;
      processed_at?: any | null;
      skip: boolean;
      status: OrderStatus;
      subscription_id: string;
      updated_at: any;
      week?: number | null;
      year?: number | null;
    }> | null;
  };
};

export type StartSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type StartSubscriptionMutation = {
  __typename?: 'Mutation';
  startSubscription: { __typename?: 'SubscriptionModel'; id: string; start_date?: any | null };
};

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type CancelSubscriptionMutation = {
  __typename?: 'Mutation';
  cancelSubscription: { __typename?: 'SubscriptionModel'; id: string; end_date?: any | null; user_id: string };
};

export type RestartSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type RestartSubscriptionMutation = {
  __typename?: 'Mutation';
  restartSubscription: {
    __typename?: 'SubscriptionModel';
    id: string;
    user_id: string;
    start_date?: any | null;
    end_date?: any | null;
    frequency: SubscriptionFrequency;
    product_variant_id: string;
    status: SubscriptionStatus;
    status_reason?: string | null;
    created_at: any;
    updated_at: any;
    product_variant?: {
      __typename?: 'MedusaProductVariant';
      id: string;
      title: string;
      sku: string;
      product_id: string;
      metadata?: any | null;
      options?: Array<{
        __typename?: 'MedusaProductOptionValue';
        id: string;
        value: string;
        option_id: string;
        variant_id: string;
      }> | null;
      variant_preference?: {
        __typename?: 'VariantPreference';
        id: string;
        user_id: string;
        product_variant_id: string;
        favorite?: boolean | null;
        never?: boolean | null;
      } | null;
      dietary_information?: {
        __typename?: 'VariantDietaryInformation';
        allergens: Array<Allergen>;
        diets: Array<DietType>;
        ingredients?: Array<string> | null;
        nutrients: {
          __typename?: 'DietaryNutrients';
          calories: number;
          carbohydrate: number;
          cholesterol: number;
          fat: number;
          fat_saturated: number;
          fat_trans: number;
          fiber: number;
          uncounted_fiber: number;
          sugar: number;
          added_sugar: number;
          sugar_alcohol: number;
          sodium: number;
          calcium: number;
          iron: number;
          vitamin_c: number;
          vitamin_a_IU: number;
          potassium: number;
          fat_monounsaturated: number;
          fat_polyunsaturated: number;
          magnesium: number;
          phosphorus: number;
          zinc: number;
          copper: number;
          manganese: number;
          selenium: number;
          thiamin: number;
          riboflavin: number;
          niacin: number;
          vitamin_b6: number;
          folate: number;
          folic_acid: number;
          chlorine: number;
          vitamin_b12: number;
          vitamin_e: number;
          vitamin_d_IU: number;
          vitamin_k: number;
          protein: number;
        };
      } | null;
      prices?: Array<{
        __typename?: 'MedusaMoneyAmount';
        id: string;
        currency_code: string;
        amount: number;
        sale_amount?: number | null;
      }> | null;
      product?: {
        __typename?: 'MedusaProduct';
        id: string;
        title: string;
        description?: string | null;
        discountable: boolean;
        is_giftcard: boolean;
        handle?: string | null;
        thumbnail?: string | null;
        tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
        variants?: Array<{
          __typename?: 'MedusaProductVariant';
          id: string;
          product_id: string;
          sku: string;
          title: string;
        }> | null;
        collection?: {
          __typename?: 'MedusaProductCollection';
          id: string;
          title?: string | null;
          handle?: string | null;
        } | null;
      } | null;
    } | null;
    current_order?: {
      __typename?: 'SubscriptionOrder';
      id: string;
      complete_order_at?: any | null;
      created_at: any;
      medusa_cart_id?: string | null;
      processed_at?: any | null;
      skip: boolean;
      status: OrderStatus;
      subscription_id: string;
      updated_at: any;
      week?: number | null;
      year?: number | null;
      medusa_cart?: {
        __typename?: 'MedusaCart';
        id: string;
        email?: string | null;
        billing_address_id?: string | null;
        shipping_address_id?: string | null;
        region_id: string;
        customer_id?: string | null;
        type: MedusaCartType;
        completed_at?: any | null;
        payment_authorized_at?: any | null;
        created_at?: any | null;
        updated_at?: any | null;
        deleted_at?: any | null;
        metadata?: any | null;
        shipping_total?: number | null;
        discount_total?: number | null;
        tax_total?: number | null;
        total?: number | null;
        subtotal?: number | null;
        gift_card_total?: number | null;
        items: Array<{
          __typename?: 'MedusaLineItem';
          id: string;
          description?: string | null;
          title?: string | null;
          quantity: number;
          allow_discounts: boolean;
          has_shipping: boolean;
          unit_price: number;
          variant_id: string;
          is_giftcard: boolean;
          thumbnail?: string | null;
          metadata?: any | null;
          created_at?: any | null;
          variant?: {
            __typename?: 'MedusaProductVariant';
            id: string;
            title: string;
            sku: string;
            product_id: string;
            metadata?: any | null;
            options?: Array<{
              __typename?: 'MedusaProductOptionValue';
              id: string;
              value: string;
              option_id: string;
              variant_id: string;
            }> | null;
            variant_preference?: {
              __typename?: 'VariantPreference';
              id: string;
              user_id: string;
              product_variant_id: string;
              favorite?: boolean | null;
              never?: boolean | null;
            } | null;
            dietary_information?: {
              __typename?: 'VariantDietaryInformation';
              allergens: Array<Allergen>;
              diets: Array<DietType>;
              ingredients?: Array<string> | null;
              nutrients: {
                __typename?: 'DietaryNutrients';
                calories: number;
                carbohydrate: number;
                cholesterol: number;
                fat: number;
                fat_saturated: number;
                fat_trans: number;
                fiber: number;
                uncounted_fiber: number;
                sugar: number;
                added_sugar: number;
                sugar_alcohol: number;
                sodium: number;
                calcium: number;
                iron: number;
                vitamin_c: number;
                vitamin_a_IU: number;
                potassium: number;
                fat_monounsaturated: number;
                fat_polyunsaturated: number;
                magnesium: number;
                phosphorus: number;
                zinc: number;
                copper: number;
                manganese: number;
                selenium: number;
                thiamin: number;
                riboflavin: number;
                niacin: number;
                vitamin_b6: number;
                folate: number;
                folic_acid: number;
                chlorine: number;
                vitamin_b12: number;
                vitamin_e: number;
                vitamin_d_IU: number;
                vitamin_k: number;
                protein: number;
              };
            } | null;
            prices?: Array<{
              __typename?: 'MedusaMoneyAmount';
              id: string;
              currency_code: string;
              amount: number;
              sale_amount?: number | null;
            }> | null;
            product?: {
              __typename?: 'MedusaProduct';
              id: string;
              title: string;
              description?: string | null;
              discountable: boolean;
              is_giftcard: boolean;
              handle?: string | null;
              thumbnail?: string | null;
              tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
              variants?: Array<{
                __typename?: 'MedusaProductVariant';
                id: string;
                product_id: string;
                sku: string;
                title: string;
              }> | null;
              collection?: {
                __typename?: 'MedusaProductCollection';
                id: string;
                title?: string | null;
                handle?: string | null;
              } | null;
            } | null;
          } | null;
        }>;
        discounts?: Array<{
          __typename?: 'MedusaDiscount';
          id: string;
          code: string;
          is_dynamic: boolean;
          rule_id: string;
          is_disabled: boolean;
          usage_limit?: number | null;
          usage_count: number;
          is_recurring?: boolean | null;
          rule: {
            __typename?: 'MedusaDiscountRule';
            id: string;
            description: string;
            type: MedusaDiscountRuleType;
            value: number;
            allocation: MedusaAllocationType;
          };
        }> | null;
        gift_cards?: Array<{
          __typename?: 'MedusaGiftCard';
          id: string;
          code: string;
          balance: number;
          value: number;
          is_disabled: boolean;
        }> | null;
      } | null;
    } | null;
    upcoming_orders?: Array<{
      __typename?: 'SubscriptionOrder';
      id: string;
      complete_order_at?: any | null;
      created_at: any;
      medusa_cart_id?: string | null;
      processed_at?: any | null;
      skip: boolean;
      status: OrderStatus;
      subscription_id: string;
      updated_at: any;
      week?: number | null;
      year?: number | null;
    }> | null;
  };
};

export type UpdateCurrentOrderLineItemMutationVariables = Exact<{
  input: UpdateLineItemInput;
}>;

export type UpdateCurrentOrderLineItemMutation = {
  __typename?: 'Mutation';
  updateCurrentOrderLineItem: {
    __typename?: 'SubscriptionOrder';
    medusa_cart?: {
      __typename?: 'MedusaCart';
      id: string;
      email?: string | null;
      billing_address_id?: string | null;
      shipping_address_id?: string | null;
      region_id: string;
      customer_id?: string | null;
      type: MedusaCartType;
      completed_at?: any | null;
      payment_authorized_at?: any | null;
      created_at?: any | null;
      updated_at?: any | null;
      deleted_at?: any | null;
      metadata?: any | null;
      shipping_total?: number | null;
      discount_total?: number | null;
      tax_total?: number | null;
      total?: number | null;
      subtotal?: number | null;
      gift_card_total?: number | null;
      items: Array<{
        __typename?: 'MedusaLineItem';
        id: string;
        description?: string | null;
        title?: string | null;
        quantity: number;
        allow_discounts: boolean;
        has_shipping: boolean;
        unit_price: number;
        variant_id: string;
        is_giftcard: boolean;
        thumbnail?: string | null;
        metadata?: any | null;
        created_at?: any | null;
        variant?: {
          __typename?: 'MedusaProductVariant';
          id: string;
          title: string;
          sku: string;
          product_id: string;
          metadata?: any | null;
          options?: Array<{
            __typename?: 'MedusaProductOptionValue';
            id: string;
            value: string;
            option_id: string;
            variant_id: string;
          }> | null;
          variant_preference?: {
            __typename?: 'VariantPreference';
            id: string;
            user_id: string;
            product_variant_id: string;
            favorite?: boolean | null;
            never?: boolean | null;
          } | null;
          dietary_information?: {
            __typename?: 'VariantDietaryInformation';
            allergens: Array<Allergen>;
            diets: Array<DietType>;
            ingredients?: Array<string> | null;
            nutrients: {
              __typename?: 'DietaryNutrients';
              calories: number;
              carbohydrate: number;
              cholesterol: number;
              fat: number;
              fat_saturated: number;
              fat_trans: number;
              fiber: number;
              uncounted_fiber: number;
              sugar: number;
              added_sugar: number;
              sugar_alcohol: number;
              sodium: number;
              calcium: number;
              iron: number;
              vitamin_c: number;
              vitamin_a_IU: number;
              potassium: number;
              fat_monounsaturated: number;
              fat_polyunsaturated: number;
              magnesium: number;
              phosphorus: number;
              zinc: number;
              copper: number;
              manganese: number;
              selenium: number;
              thiamin: number;
              riboflavin: number;
              niacin: number;
              vitamin_b6: number;
              folate: number;
              folic_acid: number;
              chlorine: number;
              vitamin_b12: number;
              vitamin_e: number;
              vitamin_d_IU: number;
              vitamin_k: number;
              protein: number;
            };
          } | null;
          prices?: Array<{
            __typename?: 'MedusaMoneyAmount';
            id: string;
            currency_code: string;
            amount: number;
            sale_amount?: number | null;
          }> | null;
          product?: {
            __typename?: 'MedusaProduct';
            id: string;
            title: string;
            description?: string | null;
            discountable: boolean;
            is_giftcard: boolean;
            handle?: string | null;
            thumbnail?: string | null;
            tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
            variants?: Array<{
              __typename?: 'MedusaProductVariant';
              id: string;
              product_id: string;
              sku: string;
              title: string;
            }> | null;
            collection?: {
              __typename?: 'MedusaProductCollection';
              id: string;
              title?: string | null;
              handle?: string | null;
            } | null;
          } | null;
        } | null;
      }>;
    } | null;
  };
};

export type CreateCancellationFeedbackMutationVariables = Exact<{
  input: CancellationFeedbackInput;
}>;

export type CreateCancellationFeedbackMutation = {
  __typename?: 'Mutation';
  createCancellationFeedback: { __typename?: 'CancellationFeedback'; id: string };
};

export type UpdateSubscriptionFrequencyMutationVariables = Exact<{
  input: UpdateSubscriptionFrequencyInput;
}>;

export type UpdateSubscriptionFrequencyMutation = {
  __typename?: 'Mutation';
  updateSubscriptionFrequency: {
    __typename?: 'SubscriptionModel';
    id: string;
    frequency: SubscriptionFrequency;
    upcoming_orders?: Array<{ __typename?: 'SubscriptionOrder'; skip: boolean }> | null;
  };
};

export type RerunSubscriptionTransactionsMutationVariables = Exact<{ [key: string]: never }>;

export type RerunSubscriptionTransactionsMutation = {
  __typename?: 'Mutation';
  rerunSubscriptionTransactions: {
    __typename?: 'SubscriptionModel';
    id: string;
    user_id: string;
    start_date?: any | null;
    end_date?: any | null;
    frequency: SubscriptionFrequency;
    product_variant_id: string;
    status: SubscriptionStatus;
    status_reason?: string | null;
    created_at: any;
    updated_at: any;
    product_variant?: {
      __typename?: 'MedusaProductVariant';
      id: string;
      title: string;
      sku: string;
      product_id: string;
      metadata?: any | null;
      options?: Array<{
        __typename?: 'MedusaProductOptionValue';
        id: string;
        value: string;
        option_id: string;
        variant_id: string;
      }> | null;
      variant_preference?: {
        __typename?: 'VariantPreference';
        id: string;
        user_id: string;
        product_variant_id: string;
        favorite?: boolean | null;
        never?: boolean | null;
      } | null;
      dietary_information?: {
        __typename?: 'VariantDietaryInformation';
        allergens: Array<Allergen>;
        diets: Array<DietType>;
        ingredients?: Array<string> | null;
        nutrients: {
          __typename?: 'DietaryNutrients';
          calories: number;
          carbohydrate: number;
          cholesterol: number;
          fat: number;
          fat_saturated: number;
          fat_trans: number;
          fiber: number;
          uncounted_fiber: number;
          sugar: number;
          added_sugar: number;
          sugar_alcohol: number;
          sodium: number;
          calcium: number;
          iron: number;
          vitamin_c: number;
          vitamin_a_IU: number;
          potassium: number;
          fat_monounsaturated: number;
          fat_polyunsaturated: number;
          magnesium: number;
          phosphorus: number;
          zinc: number;
          copper: number;
          manganese: number;
          selenium: number;
          thiamin: number;
          riboflavin: number;
          niacin: number;
          vitamin_b6: number;
          folate: number;
          folic_acid: number;
          chlorine: number;
          vitamin_b12: number;
          vitamin_e: number;
          vitamin_d_IU: number;
          vitamin_k: number;
          protein: number;
        };
      } | null;
      prices?: Array<{
        __typename?: 'MedusaMoneyAmount';
        id: string;
        currency_code: string;
        amount: number;
        sale_amount?: number | null;
      }> | null;
      product?: {
        __typename?: 'MedusaProduct';
        id: string;
        title: string;
        description?: string | null;
        discountable: boolean;
        is_giftcard: boolean;
        handle?: string | null;
        thumbnail?: string | null;
        tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
        variants?: Array<{
          __typename?: 'MedusaProductVariant';
          id: string;
          product_id: string;
          sku: string;
          title: string;
        }> | null;
        collection?: {
          __typename?: 'MedusaProductCollection';
          id: string;
          title?: string | null;
          handle?: string | null;
        } | null;
      } | null;
    } | null;
    current_order?: {
      __typename?: 'SubscriptionOrder';
      id: string;
      complete_order_at?: any | null;
      created_at: any;
      medusa_cart_id?: string | null;
      processed_at?: any | null;
      skip: boolean;
      status: OrderStatus;
      subscription_id: string;
      updated_at: any;
      week?: number | null;
      year?: number | null;
      medusa_cart?: {
        __typename?: 'MedusaCart';
        id: string;
        email?: string | null;
        billing_address_id?: string | null;
        shipping_address_id?: string | null;
        region_id: string;
        customer_id?: string | null;
        type: MedusaCartType;
        completed_at?: any | null;
        payment_authorized_at?: any | null;
        created_at?: any | null;
        updated_at?: any | null;
        deleted_at?: any | null;
        metadata?: any | null;
        shipping_total?: number | null;
        discount_total?: number | null;
        tax_total?: number | null;
        total?: number | null;
        subtotal?: number | null;
        gift_card_total?: number | null;
        items: Array<{
          __typename?: 'MedusaLineItem';
          id: string;
          description?: string | null;
          title?: string | null;
          quantity: number;
          allow_discounts: boolean;
          has_shipping: boolean;
          unit_price: number;
          variant_id: string;
          is_giftcard: boolean;
          thumbnail?: string | null;
          metadata?: any | null;
          created_at?: any | null;
          variant?: {
            __typename?: 'MedusaProductVariant';
            id: string;
            title: string;
            sku: string;
            product_id: string;
            metadata?: any | null;
            options?: Array<{
              __typename?: 'MedusaProductOptionValue';
              id: string;
              value: string;
              option_id: string;
              variant_id: string;
            }> | null;
            variant_preference?: {
              __typename?: 'VariantPreference';
              id: string;
              user_id: string;
              product_variant_id: string;
              favorite?: boolean | null;
              never?: boolean | null;
            } | null;
            dietary_information?: {
              __typename?: 'VariantDietaryInformation';
              allergens: Array<Allergen>;
              diets: Array<DietType>;
              ingredients?: Array<string> | null;
              nutrients: {
                __typename?: 'DietaryNutrients';
                calories: number;
                carbohydrate: number;
                cholesterol: number;
                fat: number;
                fat_saturated: number;
                fat_trans: number;
                fiber: number;
                uncounted_fiber: number;
                sugar: number;
                added_sugar: number;
                sugar_alcohol: number;
                sodium: number;
                calcium: number;
                iron: number;
                vitamin_c: number;
                vitamin_a_IU: number;
                potassium: number;
                fat_monounsaturated: number;
                fat_polyunsaturated: number;
                magnesium: number;
                phosphorus: number;
                zinc: number;
                copper: number;
                manganese: number;
                selenium: number;
                thiamin: number;
                riboflavin: number;
                niacin: number;
                vitamin_b6: number;
                folate: number;
                folic_acid: number;
                chlorine: number;
                vitamin_b12: number;
                vitamin_e: number;
                vitamin_d_IU: number;
                vitamin_k: number;
                protein: number;
              };
            } | null;
            prices?: Array<{
              __typename?: 'MedusaMoneyAmount';
              id: string;
              currency_code: string;
              amount: number;
              sale_amount?: number | null;
            }> | null;
            product?: {
              __typename?: 'MedusaProduct';
              id: string;
              title: string;
              description?: string | null;
              discountable: boolean;
              is_giftcard: boolean;
              handle?: string | null;
              thumbnail?: string | null;
              tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
              variants?: Array<{
                __typename?: 'MedusaProductVariant';
                id: string;
                product_id: string;
                sku: string;
                title: string;
              }> | null;
              collection?: {
                __typename?: 'MedusaProductCollection';
                id: string;
                title?: string | null;
                handle?: string | null;
              } | null;
            } | null;
          } | null;
        }>;
        discounts?: Array<{
          __typename?: 'MedusaDiscount';
          id: string;
          code: string;
          is_dynamic: boolean;
          rule_id: string;
          is_disabled: boolean;
          usage_limit?: number | null;
          usage_count: number;
          is_recurring?: boolean | null;
          rule: {
            __typename?: 'MedusaDiscountRule';
            id: string;
            description: string;
            type: MedusaDiscountRuleType;
            value: number;
            allocation: MedusaAllocationType;
          };
        }> | null;
        gift_cards?: Array<{
          __typename?: 'MedusaGiftCard';
          id: string;
          code: string;
          balance: number;
          value: number;
          is_disabled: boolean;
        }> | null;
      } | null;
    } | null;
    upcoming_orders?: Array<{
      __typename?: 'SubscriptionOrder';
      id: string;
      complete_order_at?: any | null;
      created_at: any;
      medusa_cart_id?: string | null;
      processed_at?: any | null;
      skip: boolean;
      status: OrderStatus;
      subscription_id: string;
      updated_at: any;
      week?: number | null;
      year?: number | null;
    }> | null;
  };
};

export type UnpauseSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type UnpauseSubscriptionMutation = {
  __typename?: 'Mutation';
  unpauseSubscription: {
    __typename?: 'SubscriptionModel';
    id: string;
    user_id: string;
    start_date?: any | null;
    end_date?: any | null;
    frequency: SubscriptionFrequency;
    product_variant_id: string;
    status: SubscriptionStatus;
    status_reason?: string | null;
    created_at: any;
    updated_at: any;
    product_variant?: {
      __typename?: 'MedusaProductVariant';
      id: string;
      title: string;
      sku: string;
      product_id: string;
      metadata?: any | null;
      options?: Array<{
        __typename?: 'MedusaProductOptionValue';
        id: string;
        value: string;
        option_id: string;
        variant_id: string;
      }> | null;
      variant_preference?: {
        __typename?: 'VariantPreference';
        id: string;
        user_id: string;
        product_variant_id: string;
        favorite?: boolean | null;
        never?: boolean | null;
      } | null;
      dietary_information?: {
        __typename?: 'VariantDietaryInformation';
        allergens: Array<Allergen>;
        diets: Array<DietType>;
        ingredients?: Array<string> | null;
        nutrients: {
          __typename?: 'DietaryNutrients';
          calories: number;
          carbohydrate: number;
          cholesterol: number;
          fat: number;
          fat_saturated: number;
          fat_trans: number;
          fiber: number;
          uncounted_fiber: number;
          sugar: number;
          added_sugar: number;
          sugar_alcohol: number;
          sodium: number;
          calcium: number;
          iron: number;
          vitamin_c: number;
          vitamin_a_IU: number;
          potassium: number;
          fat_monounsaturated: number;
          fat_polyunsaturated: number;
          magnesium: number;
          phosphorus: number;
          zinc: number;
          copper: number;
          manganese: number;
          selenium: number;
          thiamin: number;
          riboflavin: number;
          niacin: number;
          vitamin_b6: number;
          folate: number;
          folic_acid: number;
          chlorine: number;
          vitamin_b12: number;
          vitamin_e: number;
          vitamin_d_IU: number;
          vitamin_k: number;
          protein: number;
        };
      } | null;
      prices?: Array<{
        __typename?: 'MedusaMoneyAmount';
        id: string;
        currency_code: string;
        amount: number;
        sale_amount?: number | null;
      }> | null;
      product?: {
        __typename?: 'MedusaProduct';
        id: string;
        title: string;
        description?: string | null;
        discountable: boolean;
        is_giftcard: boolean;
        handle?: string | null;
        thumbnail?: string | null;
        tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
        variants?: Array<{
          __typename?: 'MedusaProductVariant';
          id: string;
          product_id: string;
          sku: string;
          title: string;
        }> | null;
        collection?: {
          __typename?: 'MedusaProductCollection';
          id: string;
          title?: string | null;
          handle?: string | null;
        } | null;
      } | null;
    } | null;
    current_order?: {
      __typename?: 'SubscriptionOrder';
      id: string;
      complete_order_at?: any | null;
      created_at: any;
      medusa_cart_id?: string | null;
      processed_at?: any | null;
      skip: boolean;
      status: OrderStatus;
      subscription_id: string;
      updated_at: any;
      week?: number | null;
      year?: number | null;
      medusa_cart?: {
        __typename?: 'MedusaCart';
        id: string;
        email?: string | null;
        billing_address_id?: string | null;
        shipping_address_id?: string | null;
        region_id: string;
        customer_id?: string | null;
        type: MedusaCartType;
        completed_at?: any | null;
        payment_authorized_at?: any | null;
        created_at?: any | null;
        updated_at?: any | null;
        deleted_at?: any | null;
        metadata?: any | null;
        shipping_total?: number | null;
        discount_total?: number | null;
        tax_total?: number | null;
        total?: number | null;
        subtotal?: number | null;
        gift_card_total?: number | null;
        items: Array<{
          __typename?: 'MedusaLineItem';
          id: string;
          description?: string | null;
          title?: string | null;
          quantity: number;
          allow_discounts: boolean;
          has_shipping: boolean;
          unit_price: number;
          variant_id: string;
          is_giftcard: boolean;
          thumbnail?: string | null;
          metadata?: any | null;
          created_at?: any | null;
          variant?: {
            __typename?: 'MedusaProductVariant';
            id: string;
            title: string;
            sku: string;
            product_id: string;
            metadata?: any | null;
            options?: Array<{
              __typename?: 'MedusaProductOptionValue';
              id: string;
              value: string;
              option_id: string;
              variant_id: string;
            }> | null;
            variant_preference?: {
              __typename?: 'VariantPreference';
              id: string;
              user_id: string;
              product_variant_id: string;
              favorite?: boolean | null;
              never?: boolean | null;
            } | null;
            dietary_information?: {
              __typename?: 'VariantDietaryInformation';
              allergens: Array<Allergen>;
              diets: Array<DietType>;
              ingredients?: Array<string> | null;
              nutrients: {
                __typename?: 'DietaryNutrients';
                calories: number;
                carbohydrate: number;
                cholesterol: number;
                fat: number;
                fat_saturated: number;
                fat_trans: number;
                fiber: number;
                uncounted_fiber: number;
                sugar: number;
                added_sugar: number;
                sugar_alcohol: number;
                sodium: number;
                calcium: number;
                iron: number;
                vitamin_c: number;
                vitamin_a_IU: number;
                potassium: number;
                fat_monounsaturated: number;
                fat_polyunsaturated: number;
                magnesium: number;
                phosphorus: number;
                zinc: number;
                copper: number;
                manganese: number;
                selenium: number;
                thiamin: number;
                riboflavin: number;
                niacin: number;
                vitamin_b6: number;
                folate: number;
                folic_acid: number;
                chlorine: number;
                vitamin_b12: number;
                vitamin_e: number;
                vitamin_d_IU: number;
                vitamin_k: number;
                protein: number;
              };
            } | null;
            prices?: Array<{
              __typename?: 'MedusaMoneyAmount';
              id: string;
              currency_code: string;
              amount: number;
              sale_amount?: number | null;
            }> | null;
            product?: {
              __typename?: 'MedusaProduct';
              id: string;
              title: string;
              description?: string | null;
              discountable: boolean;
              is_giftcard: boolean;
              handle?: string | null;
              thumbnail?: string | null;
              tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
              variants?: Array<{
                __typename?: 'MedusaProductVariant';
                id: string;
                product_id: string;
                sku: string;
                title: string;
              }> | null;
              collection?: {
                __typename?: 'MedusaProductCollection';
                id: string;
                title?: string | null;
                handle?: string | null;
              } | null;
            } | null;
          } | null;
        }>;
        discounts?: Array<{
          __typename?: 'MedusaDiscount';
          id: string;
          code: string;
          is_dynamic: boolean;
          rule_id: string;
          is_disabled: boolean;
          usage_limit?: number | null;
          usage_count: number;
          is_recurring?: boolean | null;
          rule: {
            __typename?: 'MedusaDiscountRule';
            id: string;
            description: string;
            type: MedusaDiscountRuleType;
            value: number;
            allocation: MedusaAllocationType;
          };
        }> | null;
        gift_cards?: Array<{
          __typename?: 'MedusaGiftCard';
          id: string;
          code: string;
          balance: number;
          value: number;
          is_disabled: boolean;
        }> | null;
      } | null;
    } | null;
    upcoming_orders?: Array<{
      __typename?: 'SubscriptionOrder';
      id: string;
      complete_order_at?: any | null;
      created_at: any;
      medusa_cart_id?: string | null;
      processed_at?: any | null;
      skip: boolean;
      status: OrderStatus;
      subscription_id: string;
      updated_at: any;
      week?: number | null;
      year?: number | null;
    }> | null;
  };
};

export type AddReturningDiscountCodeToCartMutationVariables = Exact<{ [key: string]: never }>;

export type AddReturningDiscountCodeToCartMutation = {
  __typename?: 'Mutation';
  addReturningDiscountCodeToCart: {
    __typename?: 'MedusaCart';
    id: string;
    email?: string | null;
    billing_address_id?: string | null;
    shipping_address_id?: string | null;
    region_id: string;
    customer_id?: string | null;
    type: MedusaCartType;
    completed_at?: any | null;
    payment_authorized_at?: any | null;
    created_at?: any | null;
    updated_at?: any | null;
    deleted_at?: any | null;
    metadata?: any | null;
    shipping_total?: number | null;
    discount_total?: number | null;
    tax_total?: number | null;
    total?: number | null;
    subtotal?: number | null;
    gift_card_total?: number | null;
    discounts?: Array<{
      __typename?: 'MedusaDiscount';
      id: string;
      code: string;
      is_dynamic: boolean;
      rule_id: string;
      is_disabled: boolean;
      usage_limit?: number | null;
      usage_count: number;
      is_recurring?: boolean | null;
      rule: {
        __typename?: 'MedusaDiscountRule';
        id: string;
        description: string;
        type: MedusaDiscountRuleType;
        value: number;
        allocation: MedusaAllocationType;
      };
    }> | null;
  };
};

export type LoginMutationVariables = Exact<{
  loginInput: LoginInput;
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login: { __typename?: 'LoginResponse'; token: string; user: { __typename?: 'User'; id: string } };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    id: string;
    first_name?: string | null;
    last_name?: string | null;
    is_active: boolean;
    email: string;
    email_verified: boolean;
    phone?: string | null;
    created_at: any;
    updated_at: any;
    postal_code?: string | null;
    stripe_customer_id: string;
    impersonating: boolean;
    medusa_shipping_address_id?: string | null;
    google_oauth_id?: string | null;
    facebook_oauth_id?: string | null;
    medusa_customer: {
      __typename?: 'MedusaCustomer';
      referral?: { __typename?: 'MedusaCustomerReferral'; id: string } | null;
    };
    shipping_addresses?: Array<{
      __typename?: 'StandardAddress';
      id: string;
      first_name: string;
      last_name: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      country: string;
      postal_code: string;
      is_default?: boolean | null;
    }> | null;
    meal_preferences?: {
      __typename?: 'MealPreferencesModel';
      allergens?: Array<Allergen> | null;
      diets?: Array<DietType> | null;
    } | null;
    subscription?: {
      __typename?: 'SubscriptionModel';
      id: string;
      user_id: string;
      start_date?: any | null;
      end_date?: any | null;
      frequency: SubscriptionFrequency;
      product_variant_id: string;
      status: SubscriptionStatus;
      status_reason?: string | null;
      product_variant?: {
        __typename?: 'MedusaProductVariant';
        id: string;
        title: string;
        sku: string;
        product_id: string;
        metadata?: any | null;
        options?: Array<{
          __typename?: 'MedusaProductOptionValue';
          id: string;
          value: string;
          option_id: string;
          variant_id: string;
        }> | null;
        variant_preference?: {
          __typename?: 'VariantPreference';
          id: string;
          user_id: string;
          product_variant_id: string;
          favorite?: boolean | null;
          never?: boolean | null;
        } | null;
        dietary_information?: {
          __typename?: 'VariantDietaryInformation';
          allergens: Array<Allergen>;
          diets: Array<DietType>;
          ingredients?: Array<string> | null;
          nutrients: {
            __typename?: 'DietaryNutrients';
            calories: number;
            carbohydrate: number;
            cholesterol: number;
            fat: number;
            fat_saturated: number;
            fat_trans: number;
            fiber: number;
            uncounted_fiber: number;
            sugar: number;
            added_sugar: number;
            sugar_alcohol: number;
            sodium: number;
            calcium: number;
            iron: number;
            vitamin_c: number;
            vitamin_a_IU: number;
            potassium: number;
            fat_monounsaturated: number;
            fat_polyunsaturated: number;
            magnesium: number;
            phosphorus: number;
            zinc: number;
            copper: number;
            manganese: number;
            selenium: number;
            thiamin: number;
            riboflavin: number;
            niacin: number;
            vitamin_b6: number;
            folate: number;
            folic_acid: number;
            chlorine: number;
            vitamin_b12: number;
            vitamin_e: number;
            vitamin_d_IU: number;
            vitamin_k: number;
            protein: number;
          };
        } | null;
        prices?: Array<{
          __typename?: 'MedusaMoneyAmount';
          id: string;
          currency_code: string;
          amount: number;
          sale_amount?: number | null;
        }> | null;
        product?: {
          __typename?: 'MedusaProduct';
          id: string;
          title: string;
          description?: string | null;
          discountable: boolean;
          is_giftcard: boolean;
          handle?: string | null;
          thumbnail?: string | null;
          tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
          variants?: Array<{
            __typename?: 'MedusaProductVariant';
            id: string;
            product_id: string;
            sku: string;
            title: string;
          }> | null;
          collection?: {
            __typename?: 'MedusaProductCollection';
            id: string;
            title?: string | null;
            handle?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type MyPaymentMethodsQueryVariables = Exact<{ [key: string]: never }>;

export type MyPaymentMethodsQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    payment_methods?: Array<{
      __typename?: 'StripePaymentMethod';
      id: string;
      is_default?: boolean | null;
      customer_id?: string | null;
      billing_details: {
        __typename?: 'StripeBillingDetails';
        name?: string | null;
        email?: string | null;
        phone?: string | null;
        address?: {
          __typename?: 'StripeAddress';
          line1: string;
          line2?: string | null;
          city: string;
          state: string;
          postal_code: string;
          country: string;
        } | null;
      };
      card: {
        __typename?: 'StripePaymentMethodCard';
        brand: string;
        last4: string;
        exp_month: number;
        exp_year: number;
        country: string;
      };
    }> | null;
  };
};

export type MyBoxSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type MyBoxSettingsQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    meal_preferences?: {
      __typename?: 'MealPreferencesModel';
      allergens?: Array<Allergen> | null;
      diets?: Array<DietType> | null;
    } | null;
    subscription?: {
      __typename?: 'SubscriptionModel';
      product_variant?: { __typename?: 'MedusaProductVariant'; metadata?: any | null } | null;
      current_order?: {
        __typename?: 'SubscriptionOrder';
        id: string;
        medusa_cart?: {
          __typename?: 'MedusaCart';
          discounts?: Array<{
            __typename?: 'MedusaDiscount';
            id: string;
            code: string;
            is_dynamic: boolean;
            rule_id: string;
            is_disabled: boolean;
            usage_limit?: number | null;
            usage_count: number;
            is_recurring?: boolean | null;
            rule: {
              __typename?: 'MedusaDiscountRule';
              id: string;
              description: string;
              type: MedusaDiscountRuleType;
              value: number;
              allocation: MedusaAllocationType;
            };
          }> | null;
          items: Array<{ __typename?: 'MedusaLineItem'; variant_id: string }>;
        } | null;
      } | null;
    } | null;
  };
};

export type ForgotPasswordMutationVariables = Exact<{
  forgotPasswordInput: ForgotPasswordInput;
}>;

export type ForgotPasswordMutation = { __typename?: 'Mutation'; forgotPassword: boolean };

export type ResetPasswordMutationVariables = Exact<{
  resetPasswordInput: ResetPasswordInput;
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  resetPassword: { __typename?: 'LoginResponse'; token: string };
};

export type UpdateUserProfileMutationVariables = Exact<{
  userInput: UpdateUserInput;
  updateAddressInput: UpdateAddressInput;
  setPasswordInput: SetPasswordInput;
}>;

export type UpdateUserProfileMutation = {
  __typename?: 'Mutation';
  updateUser: { __typename?: 'User'; id: string };
  updateUserShippingAddress: { __typename?: 'StandardAddress'; id: string };
  setPassword: { __typename?: 'User'; id: string };
};

export type UpdateUserMutationVariables = Exact<{
  userInput: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    first_name?: string | null;
    last_name?: string | null;
    is_active: boolean;
    email: string;
    email_verified: boolean;
    phone?: string | null;
    created_at: any;
    updated_at: any;
    postal_code?: string | null;
    stripe_customer_id: string;
    impersonating: boolean;
    medusa_shipping_address_id?: string | null;
    google_oauth_id?: string | null;
    facebook_oauth_id?: string | null;
    shipping_addresses?: Array<{
      __typename?: 'StandardAddress';
      id: string;
      first_name: string;
      last_name: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      country: string;
      postal_code: string;
      is_default?: boolean | null;
    }> | null;
    meal_preferences?: {
      __typename?: 'MealPreferencesModel';
      allergens?: Array<Allergen> | null;
      diets?: Array<DietType> | null;
    } | null;
    subscription?: {
      __typename?: 'SubscriptionModel';
      id: string;
      user_id: string;
      start_date?: any | null;
      end_date?: any | null;
      frequency: SubscriptionFrequency;
      product_variant_id: string;
      status: SubscriptionStatus;
      status_reason?: string | null;
      product_variant?: {
        __typename?: 'MedusaProductVariant';
        id: string;
        title: string;
        sku: string;
        product_id: string;
        metadata?: any | null;
        options?: Array<{
          __typename?: 'MedusaProductOptionValue';
          id: string;
          value: string;
          option_id: string;
          variant_id: string;
        }> | null;
        variant_preference?: {
          __typename?: 'VariantPreference';
          id: string;
          user_id: string;
          product_variant_id: string;
          favorite?: boolean | null;
          never?: boolean | null;
        } | null;
        dietary_information?: {
          __typename?: 'VariantDietaryInformation';
          allergens: Array<Allergen>;
          diets: Array<DietType>;
          ingredients?: Array<string> | null;
          nutrients: {
            __typename?: 'DietaryNutrients';
            calories: number;
            carbohydrate: number;
            cholesterol: number;
            fat: number;
            fat_saturated: number;
            fat_trans: number;
            fiber: number;
            uncounted_fiber: number;
            sugar: number;
            added_sugar: number;
            sugar_alcohol: number;
            sodium: number;
            calcium: number;
            iron: number;
            vitamin_c: number;
            vitamin_a_IU: number;
            potassium: number;
            fat_monounsaturated: number;
            fat_polyunsaturated: number;
            magnesium: number;
            phosphorus: number;
            zinc: number;
            copper: number;
            manganese: number;
            selenium: number;
            thiamin: number;
            riboflavin: number;
            niacin: number;
            vitamin_b6: number;
            folate: number;
            folic_acid: number;
            chlorine: number;
            vitamin_b12: number;
            vitamin_e: number;
            vitamin_d_IU: number;
            vitamin_k: number;
            protein: number;
          };
        } | null;
        prices?: Array<{
          __typename?: 'MedusaMoneyAmount';
          id: string;
          currency_code: string;
          amount: number;
          sale_amount?: number | null;
        }> | null;
        product?: {
          __typename?: 'MedusaProduct';
          id: string;
          title: string;
          description?: string | null;
          discountable: boolean;
          is_giftcard: boolean;
          handle?: string | null;
          thumbnail?: string | null;
          tags: Array<{ __typename?: 'MedusaProductTag'; id: string }>;
          variants?: Array<{
            __typename?: 'MedusaProductVariant';
            id: string;
            product_id: string;
            sku: string;
            title: string;
          }> | null;
          collection?: {
            __typename?: 'MedusaProductCollection';
            id: string;
            title?: string | null;
            handle?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type UpdateUserPaymentMethodMutationVariables = Exact<{
  updatePaymentMethodInput: StripePaymentMethodInput;
}>;

export type UpdateUserPaymentMethodMutation = {
  __typename?: 'Mutation';
  updateUserPaymentMethod: {
    __typename?: 'StripePaymentMethod';
    id: string;
    is_default?: boolean | null;
    customer_id?: string | null;
    billing_details: {
      __typename?: 'StripeBillingDetails';
      name?: string | null;
      email?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'StripeAddress';
        line1: string;
        line2?: string | null;
        city: string;
        state: string;
        postal_code: string;
        country: string;
      } | null;
    };
    card: {
      __typename?: 'StripePaymentMethodCard';
      brand: string;
      last4: string;
      exp_month: number;
      exp_year: number;
      country: string;
    };
  };
};

export type UpdateUserStripeCustomerMutationVariables = Exact<{
  updateUserStripeCustomerInput: StripeCustomerInput;
}>;

export type UpdateUserStripeCustomerMutation = {
  __typename?: 'Mutation';
  updateUserStripeCustomer: {
    __typename?: 'StripeCustomer';
    id: string;
    invoice_settings?: { __typename?: 'StripeCustomerInvoiceSettings'; default_payment_method?: string | null } | null;
  };
};

export type DetachUserPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;

export type DetachUserPaymentMethodMutation = { __typename?: 'Mutation'; detachUserPaymentMethod: boolean };

export type SetDefaultUserPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;

export type SetDefaultUserPaymentMethodMutation = {
  __typename?: 'Mutation';
  setDefaultUserPaymentMethod: {
    __typename?: 'StripePaymentMethod';
    id: string;
    is_default?: boolean | null;
    customer_id?: string | null;
    billing_details: {
      __typename?: 'StripeBillingDetails';
      name?: string | null;
      email?: string | null;
      phone?: string | null;
      address?: {
        __typename?: 'StripeAddress';
        line1: string;
        line2?: string | null;
        city: string;
        state: string;
        postal_code: string;
        country: string;
      } | null;
    };
    card: {
      __typename?: 'StripePaymentMethodCard';
      brand: string;
      last4: string;
      exp_month: number;
      exp_year: number;
      country: string;
    };
  };
};

export type MyShippingAddressesQueryVariables = Exact<{ [key: string]: never }>;

export type MyShippingAddressesQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'User';
    shipping_addresses?: Array<{
      __typename?: 'StandardAddress';
      id: string;
      customer_id?: string | null;
      company?: string | null;
      first_name: string;
      last_name: string;
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postal_code: string;
      country: string;
      phone?: string | null;
      is_default?: boolean | null;
    }> | null;
  };
};

export type CreateUserShippingAddressMutationVariables = Exact<{
  createAddressInput: CreateAddressInput;
}>;

export type CreateUserShippingAddressMutation = {
  __typename?: 'Mutation';
  createUserShippingAddress: {
    __typename?: 'StandardAddress';
    id: string;
    customer_id?: string | null;
    company?: string | null;
    first_name: string;
    last_name: string;
    line1: string;
    line2?: string | null;
    city: string;
    state: string;
    postal_code: string;
    country: string;
    phone?: string | null;
    is_default?: boolean | null;
  };
};

export type UpdateUserShippingAddressMutationVariables = Exact<{
  updateAddressInput: UpdateAddressInput;
}>;

export type UpdateUserShippingAddressMutation = {
  __typename?: 'Mutation';
  updateUserShippingAddress: {
    __typename?: 'StandardAddress';
    id: string;
    customer_id?: string | null;
    company?: string | null;
    first_name: string;
    last_name: string;
    line1: string;
    line2?: string | null;
    city: string;
    state: string;
    postal_code: string;
    country: string;
    phone?: string | null;
    is_default?: boolean | null;
  };
};

export type DeleteUserShippingAddressMutationVariables = Exact<{
  addressId: Scalars['String'];
}>;

export type DeleteUserShippingAddressMutation = { __typename?: 'Mutation'; deleteUserShippingAddress: boolean };

export type SetDefaultUserShippingAddressMutationVariables = Exact<{
  addressId: Scalars['String'];
}>;

export type SetDefaultUserShippingAddressMutation = {
  __typename?: 'Mutation';
  setDefaultUserShippingAddress: {
    __typename?: 'StandardAddress';
    id: string;
    customer_id?: string | null;
    company?: string | null;
    first_name: string;
    last_name: string;
    line1: string;
    line2?: string | null;
    city: string;
    state: string;
    postal_code: string;
    country: string;
    phone?: string | null;
    is_default?: boolean | null;
  };
};

export type VariantPreferenceQueryVariables = Exact<{
  variant_id: Scalars['String'];
}>;

export type VariantPreferenceQuery = {
  __typename?: 'Query';
  variantPreference: {
    __typename?: 'VariantPreference';
    id: string;
    user_id: string;
    product_variant_id: string;
    favorite?: boolean | null;
    never?: boolean | null;
  };
};

export type SaveFavoritePreferenceMutationVariables = Exact<{
  saveFavoritePreference: SaveFavoritePreferenceInput;
}>;

export type SaveFavoritePreferenceMutation = {
  __typename?: 'Mutation';
  saveFavoritePreference: {
    __typename?: 'VariantPreference';
    id: string;
    user_id: string;
    product_variant_id: string;
    favorite?: boolean | null;
    never?: boolean | null;
  };
};

export type SaveNeverPreferenceMutationVariables = Exact<{
  saveNeverPreference: SaveNeverPreferenceInput;
}>;

export type SaveNeverPreferenceMutation = {
  __typename?: 'Mutation';
  saveNeverPreference: {
    __typename?: 'VariantPreference';
    id: string;
    user_id: string;
    product_variant_id: string;
    favorite?: boolean | null;
    never?: boolean | null;
  };
};
